/*
@license
  Motion by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/motion/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/ (window.theme = window.theme || {}),
  (window.Shopify = window.Shopify || {}),
  (theme.config = {
    bpSmall: !1,
    bpSmallValue: 589,
    hasSessionStorage: !0,
    mediaQuerySmall: "screen and (max-width: 589px)",
    youTubeReady: !1,
    vimeoReady: !1,
    vimeoLoading: !1,
    isTouch:
      !!(
        "ontouchstart" in window ||
        (window.DocumentTouch && window.document instanceof DocumentTouch)
      ) ||
      !!window.navigator.maxTouchPoints ||
      !!window.navigator.msMaxTouchPoints,
    rtl: "rtl" == document.documentElement.getAttribute("dir"),
  }),
  theme.config.isTouch &&
    (document.documentElement.className += " supports-touch"),
  console &&
    console.log &&
    console.log(
      "Motion theme (" +
        theme.settings.themeVersion +
        ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
    ),
  (window.lazySizesConfig = window.lazySizesConfig || {}),
  (lazySizesConfig.expFactor = 2.2),
  (function () {
    "use strict";
    var e, t, i, n, s, a, o, r;
    if (
      ((theme.delegate = {
        on: function (e, t, i) {
          return (
            this.namespaces || (this.namespaces = {}),
            (this.namespaces[e] = t),
            (i = i || !1),
            this.addEventListener(e.split(".")[0], t, i),
            this
          );
        },
        off: function (e) {
          if (this.namespaces)
            return (
              this.removeEventListener(e.split(".")[0], this.namespaces[e]),
              delete this.namespaces[e],
              this
            );
        },
      }),
      (window.on = Element.prototype.on = theme.delegate.on),
      (window.off = Element.prototype.off = theme.delegate.off),
      (theme.utils = {
        defaultTo: function (e, t) {
          return null == e || e != e ? t : e;
        },
        wrap: function (e, t) {
          e.parentNode.insertBefore(t, e), t.appendChild(e);
        },
        debounce: function (e, t, i) {
          var n;
          return function () {
            var s = this,
              a = arguments,
              o = function () {
                (n = null), i || t.apply(s, a);
              },
              r = i && !n;
            clearTimeout(n), (n = setTimeout(o, e)), r && t.apply(s, a);
          };
        },
        throttle: function (e, t) {
          var i = !1;
          return function () {
            i ||
              (t.apply(this, arguments),
              (i = !0),
              setTimeout(function () {
                i = !1;
              }, e));
          };
        },
        prepareTransition: function (e, t) {
          function i(t) {
            e.classList.remove("is-transitioning"),
              e.removeEventListener("transitionend", i);
          }
          e.addEventListener("transitionend", i),
            e.classList.add("is-transitioning"),
            e.offsetWidth,
            "function" == typeof t && t();
        },
        compact: function (e) {
          for (
            var t = -1, i = null == e ? 0 : e.length, n = 0, s = [];
            ++t < i;

          ) {
            var a = e[t];
            a && (s[n++] = a);
          }
          return s;
        },
        serialize: function (e) {
          var t = [];
          return (
            Array.prototype.slice.call(e.elements).forEach(function (e) {
              if (
                !(
                  !e.name ||
                  e.disabled ||
                  ["file", "reset", "submit", "button"].indexOf(e.type) > -1
                )
              ) {
                if ("select-multiple" === e.type) {
                  Array.prototype.slice.call(e.options).forEach(function (i) {
                    i.selected &&
                      t.push(
                        encodeURIComponent(e.name) +
                          "=" +
                          encodeURIComponent(i.value)
                      );
                  });
                  return;
                }
                (!(["checkbox", "radio"].indexOf(e.type) > -1) || e.checked) &&
                  t.push(
                    encodeURIComponent(e.name) +
                      "=" +
                      encodeURIComponent(e.value)
                  );
              }
            }),
            t.join("&")
          );
        },
      }),
      (theme.a11y = {
        trapFocus: function (e) {
          var t = {
              focusin: e.namespace ? "focusin." + e.namespace : "focusin",
              focusout: e.namespace ? "focusout." + e.namespace : "focusout",
              keydown: e.namespace
                ? "keydown." + e.namespace
                : "keydown.handleFocus",
            },
            i = e.container.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            ),
            n = [].slice.call(i).filter((e) => null !== e.offsetParent),
            s = n[0],
            a = n[n.length - 1];
          e.elementToFocus || (e.elementToFocus = e.container),
            e.container.setAttribute("tabindex", "-1"),
            e.elementToFocus.focus(),
            document.documentElement.off("focusin"),
            document.documentElement.on(t.focusout, function () {
              document.documentElement.off(t.keydown);
            }),
            document.documentElement.on(t.focusin, function (e) {
              (e.target === a || e.target === s) &&
                document.documentElement.on(t.keydown, function (e) {
                  var t;
                  (t = e),
                    9 === t.keyCode &&
                      t.target === s &&
                      t.shiftKey &&
                      (t.preventDefault(), a.focus());
                });
            });
        },
        removeTrapFocus: function (e) {
          var t = e.namespace ? "focusin." + e.namespace : "focusin";
          e.container && e.container.removeAttribute("tabindex"),
            document.documentElement.off(t);
        },
        lockMobileScrolling: function (e, t) {
          var i = t || document.documentElement;
          document.documentElement.classList.add("lock-scroll"),
            i.on("touchmove" + e, function () {
              return !0;
            });
        },
        unlockMobileScrolling: function (e, t) {
          document.documentElement.classList.remove("lock-scroll"),
            (t || document.documentElement).off("touchmove" + e);
        },
      }),
      document.documentElement.on("keyup.tab", function (e) {
        9 === e.keyCode &&
          (document.documentElement.classList.add("tab-outline"),
          document.documentElement.off("keyup.tab"));
      }),
      (theme.Currency =
        ((e = theme && theme.settings && theme.settings.superScriptPrice),
        {
          formatMoney: function t(i, n) {
            n || (n = theme.settings.moneyFormat),
              "string" == typeof i && (i = i.replace(".", ""));
            var s = "",
              a = /\{\{\s*(\w+)\s*\}\}/,
              o = n || "${{amount}}";
            function r(e, t, i, n) {
              if (
                ((t = theme.utils.defaultTo(t, 2)),
                (i = theme.utils.defaultTo(i, ",")),
                (n = theme.utils.defaultTo(n, ".")),
                isNaN(e) || null == e)
              )
                return 0;
              var s,
                a = (e = (e / 100).toFixed(t)).split(".");
              return (
                a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
                (a[1] ? n + a[1] : "")
              );
            }
            switch (o.match(a)[1]) {
              case "amount":
                (s = r(i, 2)),
                  e &&
                    s &&
                    s.includes(".") &&
                    (s = s.replace(".", "<sup>") + "</sup>");
                break;
              case "amount_no_decimals":
                s = r(i, 0);
                break;
              case "amount_with_comma_separator":
                (s = r(i, 2, ".", ",")),
                  e &&
                    s &&
                    s.includes(".") &&
                    (s = s.replace(",", "<sup>") + "</sup>");
                break;
              case "amount_no_decimals_with_comma_separator":
                s = r(i, 0, ".", ",");
                break;
              case "amount_no_decimals_with_space_separator":
                s = r(i, 0, " ");
            }
            return o.replace(a, s);
          },
          getBaseUnit: function e(t) {
            if (
              t &&
              t.unit_price_measurement &&
              t.unit_price_measurement.reference_value
            )
              return 1 === t.unit_price_measurement.reference_value
                ? t.unit_price_measurement.reference_unit
                : t.unit_price_measurement.reference_value +
                    t.unit_price_measurement.reference_unit;
          },
        })),
      (theme.Images = {
        imageSize: function e(t) {
          if (!t) return "620x";
          var i = t.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );
          return null !== i ? i[1] : null;
        },
        getSizedImageUrl: function e(t, i) {
          if (!t || null == i) return t;
          if ("master" === i) return this.removeProtocol(t);
          var n = t.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (null != n) {
            var s = t.split(n[0]),
              a = n[0];
            return this.removeProtocol(s[0] + "_" + i + a);
          }
          return null;
        },
        removeProtocol: function e(t) {
          return t.replace(/http(s)?:/, "");
        },
        lazyloadImagePath: function e(t) {
          var i;
          return null !== t && (i = t.replace(/(\.[^.]*)$/, "_{width}x$1")), i;
        },
      }),
      (theme.loadImageSection = function (e) {
        function t() {
          e.classList.remove("loading", "loading--delayed"),
            e.classList.add("loaded");
        }
        function i() {
          return e.querySelector(".lazyloaded");
        }
        if (e.querySelector("svg") || i()) {
          t();
          return;
        }
        var n = setInterval(function () {
          i() && (clearInterval(n), t());
        }, 25);
      }),
      (theme.initWhenVisible = function (e) {
        var t = e.threshold ? e.threshold : 0;
        new IntersectionObserver(
          (t, i) => {
            t.forEach((t) => {
              t.isIntersecting &&
                "function" == typeof e.callback &&
                (e.callback(), i.unobserve(t.target));
            });
          },
          { rootMargin: "0px 0px " + t + "px 0px" }
        ).observe(e.element);
      }),
      (theme.LibraryLoader =
        ((i = { requested: "requested", loaded: "loaded" }),
        (n = "https://cdn.shopify.com/shopifycloud/"),
        (s = {
          youtubeSdk: {
            tagId: "youtube-sdk",
            src: "https://www.youtube.com/iframe_api",
            type: (t = { link: "link", script: "script" }).script,
          },
          vimeo: {
            tagId: "vimeo-api",
            src: "https://player.vimeo.com/api/player.js",
            type: t.script,
          },
          shopifyXr: {
            tagId: "shopify-model-viewer-xr",
            src: n + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
            type: t.script,
          },
          modelViewerUi: {
            tagId: "shopify-model-viewer-ui",
            src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
            type: t.script,
          },
          modelViewerUiStyles: {
            tagId: "shopify-model-viewer-ui-styles",
            src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            type: t.link,
          },
        }),
        {
          load: function e(n, a) {
            var o,
              r = s[n];
            if (r && r.status !== i.requested) {
              if (((a = a || function () {}), r.status === i.loaded)) {
                a();
                return;
              }
              switch (((r.status = i.requested), r.type)) {
                case t.script:
                  o =
                    ((c = r),
                    (l = a),
                    (d = document.createElement("script")),
                    (d.src = c.src),
                    d.addEventListener("load", function () {
                      (c.status = i.loaded), l();
                    }),
                    d);
                  break;
                case t.link:
                  o =
                    ((h = r),
                    (u = a),
                    (p = document.createElement("link")),
                    (p.href = h.src),
                    (p.rel = "stylesheet"),
                    (p.type = "text/css"),
                    p.addEventListener("load", function () {
                      (h.status = i.loaded), u();
                    }),
                    p);
              }
              (o.id = r.tagId), (r.element = o);
              var c,
                l,
                d,
                h,
                u,
                p,
                f = document.getElementsByTagName(r.type)[0];
              f.parentNode.insertBefore(o, f);
            }
          },
        })),
      (theme.rteInit = function () {
        function e(e) {
          e.src = e.src;
          var t = document.createElement("div");
          t.classList.add("video-wrapper"), theme.utils.wrap(e, t);
        }
        document.querySelectorAll(".rte table").forEach((e) => {
          var t = document.createElement("div");
          t.classList.add("table-wrapper"), theme.utils.wrap(e, t);
        }),
          document
            .querySelectorAll('.rte iframe[src*="youtube.com/embed"]')
            .forEach((t) => {
              e(t);
            }),
          document
            .querySelectorAll('.rte iframe[src*="player.vimeo"]')
            .forEach((t) => {
              e(t);
            }),
          document.querySelectorAll(".rte a img").forEach((e) => {
            e.parentNode.classList.add("rte__image");
          });
      }),
      (theme.Sections = function e() {
        (this.constructors = {}),
          (this.instances = []),
          document.addEventListener(
            "shopify:section:load",
            this._onSectionLoad.bind(this)
          ),
          document.addEventListener(
            "shopify:section:unload",
            this._onSectionUnload.bind(this)
          ),
          document.addEventListener(
            "shopify:section:select",
            this._onSelect.bind(this)
          ),
          document.addEventListener(
            "shopify:section:deselect",
            this._onDeselect.bind(this)
          ),
          document.addEventListener(
            "shopify:block:select",
            this._onBlockSelect.bind(this)
          ),
          document.addEventListener(
            "shopify:block:deselect",
            this._onBlockDeselect.bind(this)
          );
      }),
      (theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
        _createInstance: function (e, t, i) {
          var n = e.getAttribute("data-section-id"),
            s = e.getAttribute("data-section-type");
          if (void 0 !== (t = t || this.constructors[s])) {
            i && this._findInstance(n) && this._removeInstance(n);
            try {
              var a = Object.assign(new t(e), { id: n, type: s, container: e });
              this.instances.push(a);
            } catch (o) {
              console.error(o);
            }
          }
        },
        _findInstance: function (e) {
          for (var t = 0; t < this.instances.length; t++)
            if (this.instances[t].id === e) return this.instances[t];
        },
        _removeInstance: function (e) {
          for (var t, i = this.instances.length; i--; )
            if (this.instances[i].id === e) {
              (t = this.instances[i]), this.instances.splice(i, 1);
              break;
            }
          return t;
        },
        _onSectionLoad: function (e, t, i) {
          window.AOS && AOS.refreshHard(),
            theme && theme.initGlobals && theme.initGlobals();
          var n = t || e.target,
            s = t || e.target.querySelector("[data-section-id]");
          if (s) {
            this._createInstance(s);
            var a = t ? i : this._findInstance(e.detail.sectionId);
            n.querySelectorAll("[data-subsection]").length &&
              this.loadSubSections(n),
              a && "function" == typeof a.onLoad && a.onLoad(e),
              setTimeout(function () {
                window.dispatchEvent(new Event("scroll"));
              }, 200);
          }
        },
        _onSectionUnload: function (e) {
          this.instances = this.instances.filter(function (t) {
            var i = t.id === e.detail.sectionId;
            return i && "function" == typeof t.onUnload && t.onUnload(e), !i;
          });
        },
        loadSubSections: function (e) {
          e &&
            e.querySelectorAll("[data-section-id]").forEach((e) => {
              this._onSectionLoad(null, e, e.dataset.sectionId);
            });
        },
        _onSelect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t && "function" == typeof t.onSelect && t.onSelect(e);
        },
        _onDeselect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t && "function" == typeof t.onDeselect && t.onDeselect(e);
        },
        _onBlockSelect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t &&
            "function" == typeof t.onBlockSelect &&
            t.onBlockSelect(e);
        },
        _onBlockDeselect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t &&
            "function" == typeof t.onBlockDeselect &&
            t.onBlockDeselect(e);
        },
        register: function (e, t, i) {
          this.constructors[e] = t;
          var n = document.querySelectorAll('[data-section-type="' + e + '"]');
          i && (n = i.querySelectorAll('[data-section-type="' + e + '"]')),
            n.forEach(
              function (e) {
                this._createInstance(e, t, i);
              }.bind(this)
            );
        },
        reinit: function (e) {
          for (var t = 0; t < this.instances.length; t++) {
            var i = this.instances[t];
            i.type === e &&
              "function" == typeof i.forceReload &&
              i.forceReload();
          }
        },
      })),
      (theme.Variants = (function () {
        function e(e) {
          (this.container = e.container),
            (this.variants = e.variants),
            (this.singleOptionSelector = e.singleOptionSelector),
            (this.originalSelectorId = e.originalSelectorId),
            (this.enableHistoryState = e.enableHistoryState),
            (this.currentlySelectedValues = this._getCurrentOptions()),
            (this.currentVariant = this._getVariantFromOptions()),
            this.container
              .querySelectorAll(this.singleOptionSelector)
              .forEach((e) => {
                e.addEventListener("change", this._onSelectChange.bind(this));
              });
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            _getCurrentOptions: function () {
              var e = [];
              return (
                this.container
                  .querySelectorAll(this.singleOptionSelector)
                  .forEach((t) => {
                    var i = t.getAttribute("type");
                    "radio" === i || "checkbox" === i
                      ? t.checked &&
                        e.push({ value: t.value, index: t.dataset.index })
                      : e.push({ value: t.value, index: t.dataset.index });
                  }),
                (e = theme.utils.compact(e))
              );
            },
            _numberFromOptionKey: function (e) {
              return parseInt(e.substr(-1));
            },
            _getWeightedOptionMatchCount: function (e) {
              return this._getCurrentOptions().reduce(
                (t, { value: i, index: n }) => {
                  let s = this._numberFromOptionKey(n);
                  return e[n] === i ? t + (4 - s) : t;
                },
                0
              );
            },
            _getFullMatch(e) {
              let t = this._getCurrentOptions(),
                i = this.variants;
              return i.find((i) => {
                let n = t.every(({ value: e, index: t }) => i[t] === e);
                return e ? n && i.available : n;
              });
            },
            _getClosestAvailableMatch: function (e) {
              if (!e) return null;
              let t = this._getCurrentOptions(),
                i = this.variants,
                n =
                  e &&
                  i.filter(
                    (i) =>
                      t
                        .filter(
                          ({ value: t, index: i }) =>
                            this._numberFromOptionKey(i) <=
                            this._numberFromOptionKey(e.index)
                        )
                        .every(({ value: e, index: t }) => i[t] === e) &&
                      i.available
                  );
              return n.reduce((t, i) => {
                if (null === t) return i;
                let n = this._getWeightedOptionMatchCount(t, e),
                  s = this._getWeightedOptionMatchCount(i, e);
                return s > n ? i : t;
              }, null);
            },
            _getVariantFromOptions: function (e) {
              let t = this._getFullMatch(!0),
                i = this._getClosestAvailableMatch(e),
                n = this._getFullMatch(!1);
              return t || i || n || null;
            },
            _updateInputState: function (e, t) {
              return (t) => {
                if (null === e) return;
                let i = t.dataset.index,
                  n = t.value,
                  s = t.getAttribute("type");
                ("radio" === s || "checkbox" === s) && (t.checked = e[i] === n);
              };
            },
            _onSelectChange: function ({ srcElement: e }) {
              let t = this.container.querySelectorAll(
                  this.singleOptionSelector
                ),
                i = this._getVariantFromOptions({
                  index: e.dataset.index,
                  value: e.value,
                });
              t.forEach(this._updateInputState(i, e));
              let n = (this.currentlySelectedValues =
                  this._getCurrentOptions()),
                s = {
                  variant: i,
                  currentlySelectedValues: n,
                  value: e.value,
                  index: e.parentElement.dataset.index,
                };
              this.container.dispatchEvent(
                new CustomEvent("variantChange", { detail: s })
              ),
                document.dispatchEvent(
                  new CustomEvent("variant:change", { detail: s })
                ),
                i &&
                  (this._updateMasterSelect(i),
                  this._updateImages(i),
                  this._updatePrice(i),
                  this._updateUnitPrice(i),
                  this._updateSKU(i),
                  (this.currentVariant = i),
                  this.enableHistoryState && this._updateHistoryState(i));
            },
            _updateImages: function (e) {
              var t = e.featured_image || {},
                i =
                  (this.currentVariant && this.currentVariant.featured_image) ||
                  {};
              e.featured_image &&
                t.src !== i.src &&
                this.container.dispatchEvent(
                  new CustomEvent("variantImageChange", {
                    detail: { variant: e },
                  })
                );
            },
            _updatePrice: function (e) {
              (!this.currentVariant ||
                e.price !== this.currentVariant.price ||
                e.compare_at_price !== this.currentVariant.compare_at_price) &&
                this.container.dispatchEvent(
                  new CustomEvent("variantPriceChange", {
                    detail: { variant: e },
                  })
                );
            },
            _updateUnitPrice: function (e) {
              (!this.currentVariant ||
                e.unit_price !== this.currentVariant.unit_price) &&
                this.container.dispatchEvent(
                  new CustomEvent("variantUnitPriceChange", {
                    detail: { variant: e },
                  })
                );
            },
            _updateSKU: function (e) {
              (!this.currentVariant || e.sku !== this.currentVariant.sku) &&
                this.container.dispatchEvent(
                  new CustomEvent("variantSKUChange", {
                    detail: { variant: e },
                  })
                );
            },
            _updateHistoryState: function (e) {
              if (history.replaceState && e) {
                var t =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  window.location.pathname +
                  "?variant=" +
                  e.id;
                window.history.replaceState({ path: t }, "", t);
              }
            },
            _updateMasterSelect: function (e) {
              (this.container.querySelector(this.originalSelectorId).value =
                e.id),
                this.container
                  .querySelector(this.originalSelectorId)
                  .dispatchEvent(new Event("change", { bubbles: !0 }));
            },
          })),
          e
        );
      })()),
      (window.vimeoApiReady = function () {
        var e, t;
        (theme.config.vimeoLoading = !0),
          new Promise((i, n) => {
            (e = setInterval(function () {
              Vimeo && (clearInterval(e), clearTimeout(t), i());
            }, 500)),
              (t = setTimeout(function () {
                clearInterval(e), n();
              }, 4e3));
          }).then(function () {
            (theme.config.vimeoReady = !0),
              (theme.config.vimeoLoading = !1),
              document.dispatchEvent(new CustomEvent("vimeoReady"));
          });
      }),
      (theme.VimeoPlayer = (function () {
        var e = {
            loading: "loading",
            loaded: "loaded",
            interactable: "video-interactable",
          },
          t = {
            background: !0,
            byline: !1,
            controls: !1,
            loop: !0,
            muted: !0,
            playsinline: !0,
            portrait: !1,
            title: !1,
          };
        function i(e, t, i) {
          (this.divId = e),
            (this.el = document.getElementById(e)),
            (this.videoId = t),
            (this.iframe = null),
            (this.options = i),
            this.options &&
              this.options.videoParent &&
              (this.parent = this.el.closest(this.options.videoParent)),
            this.setAsLoading(),
            theme.config.vimeoReady
              ? this.init()
              : (theme.LibraryLoader.load("vimeo", window.vimeoApiReady),
                document.addEventListener("vimeoReady", this.init.bind(this)));
        }
        return (
          (i.prototype = Object.assign({}, i.prototype, {
            init: function () {
              var e = t;
              (e.id = this.videoId),
                (this.videoPlayer = new Vimeo.Player(this.el, e)),
                this.videoPlayer.ready().then(this.playerReady.bind(this));
            },
            playerReady: function () {
              (this.iframe = this.el.querySelector("iframe")),
                this.iframe.setAttribute("tabindex", "-1"),
                this.videoPlayer.setMuted(!0),
                this.setAsLoaded(),
                new IntersectionObserver(
                  (e, t) => {
                    e.forEach((e) => {
                      e.isIntersecting ? this.play() : this.pause();
                    });
                  },
                  { rootMargin: "0px 0px 50px 0px" }
                ).observe(this.iframe);
            },
            setAsLoading: function () {
              this.parent && this.parent.classList.add(e.loading);
            },
            setAsLoaded: function () {
              this.parent &&
                (this.parent.classList.remove(e.loading),
                this.parent.classList.add(e.loaded),
                Shopify &&
                  Shopify.designMode &&
                  window.AOS &&
                  AOS.refreshHard());
            },
            enableInteraction: function () {
              this.parent && this.parent.classList.add(e.interactable);
            },
            play: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.play &&
                this.videoPlayer.play();
            },
            pause: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.pause &&
                this.videoPlayer.pause();
            },
            destroy: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.destroy &&
                this.videoPlayer.destroy();
            },
          })),
          i
        );
      })()),
      (window.onYouTubeIframeAPIReady = function () {
        (theme.config.youTubeReady = !0),
          document.dispatchEvent(new CustomEvent("youTubeReady"));
      }),
      (theme.YouTube = (function () {
        var e = {
            loading: "loading",
            loaded: "loaded",
            interactable: "video-interactable",
          },
          t = {
            width: 1280,
            height: 720,
            playerVars: {
              autohide: 0,
              autoplay: 1,
              cc_load_policy: 0,
              controls: 0,
              fs: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              rel: 0,
            },
          };
        function i(e, i) {
          (this.divId = e),
            (this.iframe = null),
            (this.attemptedToPlay = !1),
            (t.events = {
              onReady: this.onVideoPlayerReady.bind(this),
              onStateChange: this.onVideoStateChange.bind(this),
            }),
            (this.options = Object.assign({}, t, i)),
            this.options &&
              (this.options.videoParent &&
                (this.parent = document
                  .getElementById(this.divId)
                  .closest(this.options.videoParent)),
              this.options.autoplay ||
                (this.options.playerVars.autoplay = this.options.autoplay),
              "sound" === this.options.style &&
                ((this.options.playerVars.controls = 1),
                (this.options.playerVars.autoplay = 0))),
            this.setAsLoading(),
            theme.config.youTubeReady
              ? this.init()
              : (theme.LibraryLoader.load("youtubeSdk"),
                document.addEventListener(
                  "youTubeReady",
                  this.init.bind(this)
                ));
        }
        return (
          (i.prototype = Object.assign({}, i.prototype, {
            init: function () {
              this.videoPlayer = new YT.Player(this.divId, this.options);
            },
            onVideoPlayerReady: function (e) {
              (this.iframe = document.getElementById(this.divId)),
                this.iframe.setAttribute("tabindex", "-1"),
                "sound" !== this.options.style && e.target.mute(),
                new IntersectionObserver(
                  (e, t) => {
                    e.forEach((e) => {
                      e.isIntersecting ? this.play() : this.pause();
                    });
                  },
                  { rootMargin: "0px 0px 50px 0px" }
                ).observe(this.iframe);
            },
            onVideoStateChange: function (e) {
              switch (e.data) {
                case -1:
                  this.attemptedToPlay &&
                    (this.setAsLoaded(), this.enableInteraction());
                  break;
                case 0:
                  this.play(e);
                  break;
                case 1:
                  this.setAsLoaded();
                  break;
                case 3:
                  this.attemptedToPlay = !0;
              }
            },
            setAsLoading: function () {
              this.parent && this.parent.classList.add(e.loading);
            },
            setAsLoaded: function () {
              this.parent &&
                (this.parent.classList.remove(e.loading),
                this.parent.classList.add(e.loaded),
                Shopify &&
                  Shopify.designMode &&
                  window.AOS &&
                  AOS.refreshHard());
            },
            enableInteraction: function () {
              this.parent && this.parent.classList.add(e.interactable);
            },
            play: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.playVideo &&
                this.videoPlayer.playVideo();
            },
            pause: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.pauseVideo &&
                this.videoPlayer.pauseVideo();
            },
            destroy: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.destroy &&
                this.videoPlayer.destroy();
            },
          })),
          i
        );
      })()),
      (o = !1),
      document.body.addEventListener("touchstart", function (e) {
        if (!e.target.closest(".flickity-slider")) return (o = !1);
        (o = !0), (a = { x: e.touches[0].pageX, y: e.touches[0].pageY });
      }),
      document.body.addEventListener(
        "touchmove",
        function (e) {
          o &&
            e.cancelable &&
            Math.abs(
              { x: e.touches[0].pageX - a.x, y: e.touches[0].pageY - a.y }.x
            ) > Flickity.defaults.dragThreshold &&
            e.preventDefault();
        },
        { passive: !1 }
      ),
      (theme.AjaxRenderer = (function () {
        function e({ sections: e, onReplace: t, debug: i } = {}) {
          (this.sections = e || []),
            (this.cachedSections = []),
            (this.onReplace = t),
            (this.debug = Boolean(i));
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            renderPage: function (e, t, i = !0) {
              let n = new URLSearchParams(window.location.search),
                s = this.getUpdatedParams(n, t),
                a = this.sections.map((t) => {
                  let i = `${e}?section_id=${t.sectionId}&${s.toString()}`,
                    n = (e) => e.url === i;
                  return this.cachedSections.some(n)
                    ? this.renderSectionFromCache(n, t)
                    : this.renderSectionFromFetch(i, t);
                });
              return i && this.updateURLHash(s), Promise.all(a);
            },
            renderSectionFromCache: function (e, t) {
              let i = this.cachedSections.find(e);
              return (
                this.log(`[AjaxRenderer] rendering from cache: url=${i.url}`),
                this.renderSection(i.html, t),
                Promise.resolve(t)
              );
            },
            renderSectionFromFetch: function (e, t) {
              return (
                this.log(`[AjaxRenderer] redering from fetch: url=${e}`),
                new Promise((i, n) => {
                  fetch(e)
                    .then((e) => e.text())
                    .then((n) => {
                      let s = n;
                      (this.cachedSections = [
                        ...this.cachedSections,
                        { html: s, url: e },
                      ]),
                        this.renderSection(s, t),
                        i(t);
                    })
                    .catch((e) => n(e));
                })
              );
            },
            renderSection: function (e, t) {
              this.log(
                `[AjaxRenderer] rendering section: section=${JSON.stringify(t)}`
              );
              let i = new DOMParser().parseFromString(e, "text/html");
              if (this.onReplace) this.onReplace(i, t);
              else if ("string" == typeof t.nodeId) {
                var n = i.getElementById(t.nodeId);
                if (!n) return;
                document.getElementById(t.nodeId).innerHTML = n.innerHTML;
              } else
                t.nodeId.forEach((e) => {
                  document.getElementById(e).innerHTML =
                    i.getElementById(e).innerHTML;
                });
              return t;
            },
            getUpdatedParams: function (e, t) {
              let i = new URLSearchParams(e),
                n = ["sort_by", "q", "options[prefix]", "type"];
              for (let [s, a] of i.entries())
                t.getAll(s).includes(a) || n.includes(s) || i.delete(s);
              for (let [o, r] of t.entries())
                i.getAll(o).includes(r) || "" === r || i.append(o, r);
              return i;
            },
            updateURLHash: function (e) {
              history.pushState(
                {},
                "",
                `${window.location.pathname}${e && "?".concat(e)}`
              );
            },
            log: function (...e) {
              this.debug && console.log(...e);
            },
          })),
          e
        );
      })()),
      window.Shopify &&
        window.Shopify.theme &&
        navigator &&
        navigator.sendBeacon &&
        window.Shopify.designMode &&
        navigator.sendBeacon(
          "https://api.archetypethemes.co/api/beacon",
          new URLSearchParams({
            shop: window.Shopify.shop,
            themeName:
              window.theme &&
              window.theme.settings &&
              `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
            role: window.Shopify.theme.role,
            route: window.location.pathname,
            themeId: window.Shopify.theme.id,
            themeStoreId: window.Shopify.theme.theme_store_id || 0,
            isThemeEditor: !!window.Shopify.designMode,
          })
        ),
      (theme.cart = {
        getCart: function () {
          return fetch("".concat(theme.routes.cart, "?t=").concat(Date.now()), {
            credentials: "same-origin",
            method: "GET",
          }).then((e) => e.json());
        },
        getCartProductMarkup: function () {
          var e = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
          return fetch(
            (e = -1 === e.indexOf("?") ? e + "?view=ajax" : e + "&view=ajax"),
            { credentials: "same-origin", method: "GET" }
          ).then(function (e) {
            return e.text();
          });
        },
        changeItem: function (e, t) {
          return this._updateCart({
            url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
            data: JSON.stringify({ id: e, quantity: t }),
          });
        },
        _updateCart: function (e) {
          return fetch(e.url, {
            method: "POST",
            body: e.data,
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          })
            .then((e) => e.json())
            .then(function (e) {
              return e;
            });
        },
        updateAttribute: function (e, t) {
          return this._updateCart({
            url: "/cart/update.js",
            data: JSON.stringify({
              attributes: { [e]: theme.cart.attributeToString(t) },
            }),
          });
        },
        updateNote: function (e) {
          return this._updateCart({
            url: "/cart/update.js",
            data: JSON.stringify({ note: theme.cart.attributeToString(e) }),
          });
        },
        attributeToString: function (e) {
          return (
            "string" != typeof e && "undefined" == (e += "") && (e = ""),
            e.trim()
          );
        },
      }),
      (theme.CartForm = (function () {
        var e = {
            products: "[data-products]",
            qtySelector: ".js-qty__wrapper",
            discounts: "[data-discounts]",
            savings: "[data-savings]",
            subTotal: "[data-subtotal]",
            cartBubble: ".cart-link__bubble",
            cartNote: '[name="note"]',
            termsCheckbox: ".cart__terms-checkbox",
            checkoutBtn: ".cart__checkout",
          },
          t = { btnLoading: "btn--loading" },
          i = { requiresTerms: !1 };
        function n(t) {
          t &&
            ((this.form = t),
            (this.wrapper = t.parentNode),
            (this.location = t.dataset.location),
            (this.namespace = ".cart-" + this.location),
            (this.products = t.querySelector(e.products)),
            (this.submitBtn = t.querySelector(e.checkoutBtn)),
            (this.discounts = t.querySelector(e.discounts)),
            (this.savings = t.querySelector(e.savings)),
            (this.subtotal = t.querySelector(e.subTotal)),
            (this.termsCheckbox = t.querySelector(e.termsCheckbox)),
            (this.noteInput = t.querySelector(e.cartNote)),
            this.termsCheckbox && (i.requiresTerms = !0),
            this.init());
        }
        return (
          (n.prototype = Object.assign({}, n.prototype, {
            init: function () {
              this.initQtySelectors(),
                document.addEventListener(
                  "cart:quantity" + this.namespace,
                  this.quantityChanged.bind(this)
                ),
                this.form.on(
                  "submit" + this.namespace,
                  this.onSubmit.bind(this)
                ),
                this.noteInput &&
                  this.noteInput.addEventListener("change", function () {
                    var e = this.value;
                    theme.cart.updateNote(e);
                  }),
                document.addEventListener(
                  "cart:build",
                  function () {
                    this.buildCart();
                  }.bind(this)
                );
            },
            reInit: function () {
              this.initQtySelectors();
            },
            onSubmit: function (e) {
              if (
                (this.submitBtn.classList.add(t.btnLoading),
                i.requiresTerms && !this.termsCheckbox.checked)
              )
                return (
                  alert(theme.strings.cartTermsConfirmation),
                  this.submitBtn.classList.remove(t.btnLoading),
                  e.preventDefault(),
                  !1
                );
            },
            _parseProductHTML: function (e) {
              var t = new DOMParser().parseFromString(e, "text/html");
              return {
                items: t.querySelector(".cart__items"),
                discounts: t.querySelector(".cart__discounts"),
              };
            },
            buildCart: function () {
              theme.cart
                .getCartProductMarkup()
                .then(this.cartMarkup.bind(this));
            },
            cartMarkup: function (e) {
              var t = this._parseProductHTML(e),
                i = t.items,
                n = parseInt(i.dataset.count),
                s = i.dataset.cartSubtotal,
                a = i.dataset.cartSavings;
              this.updateCartDiscounts(t.discounts),
                this.updateSavings(a),
                n > 0
                  ? this.wrapper.classList.remove("is-empty")
                  : this.wrapper.classList.add("is-empty"),
                this.updateCount(n),
                (this.products.innerHTML = ""),
                this.products.append(i),
                (this.subtotal.innerHTML = theme.Currency.formatMoney(
                  s,
                  theme.settings.moneyFormat
                )),
                this.reInit(),
                window.AOS && AOS.refreshHard(),
                Shopify &&
                  Shopify.StorefrontExpressButtons &&
                  Shopify.StorefrontExpressButtons.initialize();
            },
            updateCartDiscounts: function (e) {
              this.discounts &&
                ((this.discounts.innerHTML = ""), this.discounts.append(e));
            },
            initQtySelectors: function () {
              this.form.querySelectorAll(e.qtySelector).forEach((e) => {
                new theme.QtySelector(e, {
                  namespace: this.namespace,
                  isCart: !0,
                });
              });
            },
            quantityChanged: function (e) {
              var t = e.detail[0],
                i = e.detail[1],
                n = e.detail[2];
              t &&
                i &&
                (n && n.classList.add("is-loading"),
                theme.cart
                  .changeItem(t, i)
                  .then(
                    function (e) {
                      e.item_count > 0
                        ? this.wrapper.classList.remove("is-empty")
                        : this.wrapper.classList.add("is-empty"),
                        this.buildCart(),
                        document.dispatchEvent(
                          new CustomEvent("cart:updated", {
                            detail: { cart: e },
                          })
                        );
                    }.bind(this)
                  )
                  .catch(function (e) {}));
            },
            updateSubtotal: function (t) {
              this.form.querySelector(e.subTotal).innerHTML =
                theme.Currency.formatMoney(t, theme.settings.moneyFormat);
            },
            updateSavings: function (e) {
              if (this.savings) {
                if (e > 0) {
                  var t = theme.Currency.formatMoney(
                    e,
                    theme.settings.moneyFormat
                  );
                  this.savings.classList.remove("hide"),
                    (this.savings.innerHTML = theme.strings.cartSavings.replace(
                      "[savings]",
                      t
                    ));
                } else this.savings.classList.add("hide");
              }
            },
            updateCount: function (t) {
              var i = document.querySelectorAll(".cart-link__bubble-num");
              i.length &&
                i.forEach((e) => {
                  e.textContent = `${t}`;
                });
              var n = document.querySelectorAll(e.cartBubble);
              n.length &&
                (t > 0
                  ? n.forEach((e) => {
                      e.classList.add("cart-link__bubble--visible");
                    })
                  : n.forEach((e) => {
                      e.classList.remove("cart-link__bubble--visible");
                    }));
            },
          })),
          n
        );
      })()),
      (theme.collapsibles = (function () {
        var e = {
            trigger: ".collapsible-trigger",
            module: ".collapsible-content",
            moduleInner: ".collapsible-content__inner",
            tabs: ".collapsible-trigger--tab",
          },
          t = {
            hide: "hide",
            open: "is-open",
            autoHeight: "collapsible--auto-height",
            tabs: "collapsible-trigger--tab",
          },
          i = ".collapsible",
          n = !1;
        function s(s) {
          if (!n) {
            n = !0;
            var o,
              r = s.currentTarget,
              c = r.classList.contains(t.open),
              l = r.classList.contains(t.tabs),
              d = r.getAttribute("aria-controls"),
              h = document.getElementById(d);
            if ((d || (d = r.dataset.controls), d)) {
              if (
                (!h &&
                  document.querySelectorAll('[data-id="' + d + '"]').length >
                    0 &&
                  (h = r.parentNode.querySelector('[data-id="' + d + '"]')),
                !h)
              ) {
                n = !1;
                return;
              }
              var u = h.querySelector(e.moduleInner).offsetHeight,
                p = h.classList.contains(t.autoHeight),
                f = h.parentNode.closest(e.module),
                m = u;
              if (l) {
                if (c) {
                  n = !1;
                  return;
                }
                document
                  .querySelectorAll(e.tabs + '[data-id="' + r.dataset.id + '"]')
                  .forEach((e) => {
                    e.classList.remove(t.open),
                      a(
                        (o = document.querySelector(
                          "#" + e.getAttribute("aria-controls")
                        )),
                        0,
                        !0
                      );
                  });
              }
              if (
                (c &&
                  p &&
                  setTimeout(function () {
                    a(h, (u = 0), c, p);
                  }, 0),
                c && !p && (u = 0),
                r.setAttribute("aria-expanded", !c),
                c ? r.classList.remove(t.open) : r.classList.add(t.open),
                a(h, u, c, p),
                f)
              ) {
                var g = f.style.height;
                c && "auto" === g && (m = 0);
                var v = c ? f.offsetHeight - m : u + f.offsetHeight;
                a(f, v, !1, !1);
              }
              if (window.SPR) {
                var y = h.querySelector(".spr-summary-actions-newreview");
                if (!y) return;
                y.off("click" + i),
                  y.on("click" + i, function () {
                    (u = h.querySelector(e.moduleInner).offsetHeight),
                      a(h, u, c, p);
                  });
              }
            }
          }
        }
        function a(e, i, s, a) {
          if (
            (e.classList.remove(t.hide),
            theme.utils.prepareTransition(e, function () {
              (e.style.height = i + "px"),
                s ? e.classList.remove(t.open) : e.classList.add(t.open);
            }),
            !s && a)
          ) {
            var o = e;
            window.setTimeout(function () {
              o.css("height", "auto"), (n = !1);
            }, 500);
          } else n = !1;
        }
        return {
          init: function n(a) {
            (a || document).querySelectorAll(e.trigger).forEach((e) => {
              var n = e.classList.contains(t.open);
              e.setAttribute("aria-expanded", n),
                e.off("click" + i),
                e.on("click" + i, s);
            });
          },
        };
      })()),
      (theme.Disclosure = (function () {
        var e = {
            disclosureForm: "[data-disclosure-form]",
            disclosureList: "[data-disclosure-list]",
            disclosureToggle: "[data-disclosure-toggle]",
            disclosureInput: "[data-disclosure-input]",
            disclosureOptions: "[data-disclosure-option]",
          },
          t = { listVisible: "disclosure-list--visible" };
        function i(e) {
          (this.container = e), this._cacheSelectors(), this._setupListeners();
        }
        return (
          (i.prototype = Object.assign({}, i.prototype, {
            _cacheSelectors: function () {
              this.cache = {
                disclosureForm: this.container.closest(e.disclosureForm),
                disclosureList: this.container.querySelector(e.disclosureList),
                disclosureToggle: this.container.querySelector(
                  e.disclosureToggle
                ),
                disclosureInput: this.container.querySelector(
                  e.disclosureInput
                ),
                disclosureOptions: this.container.querySelectorAll(
                  e.disclosureOptions
                ),
              };
            },
            _setupListeners: function () {
              (this.eventHandlers = this._setupEventHandlers()),
                this.cache.disclosureToggle.addEventListener(
                  "click",
                  this.eventHandlers.toggleList
                ),
                this.cache.disclosureOptions.forEach(function (e) {
                  e.addEventListener(
                    "click",
                    this.eventHandlers.connectOptions
                  );
                }, this),
                this.container.addEventListener(
                  "keyup",
                  this.eventHandlers.onDisclosureKeyUp
                ),
                this.cache.disclosureList.addEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureListFocusOut
                ),
                this.cache.disclosureToggle.addEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureToggleFocusOut
                ),
                document.body.addEventListener(
                  "click",
                  this.eventHandlers.onBodyClick
                );
            },
            _setupEventHandlers: function () {
              return {
                connectOptions: this._connectOptions.bind(this),
                toggleList: this._toggleList.bind(this),
                onBodyClick: this._onBodyClick.bind(this),
                onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                onDisclosureListFocusOut:
                  this._onDisclosureListFocusOut.bind(this),
                onDisclosureToggleFocusOut:
                  this._onDisclosureToggleFocusOut.bind(this),
              };
            },
            _connectOptions: function (e) {
              e.preventDefault(),
                this._submitForm(e.currentTarget.dataset.value);
            },
            _onDisclosureToggleFocusOut: function (e) {
              !1 === this.container.contains(e.relatedTarget) &&
                this._hideList();
            },
            _onDisclosureListFocusOut: function (e) {
              var i = e.currentTarget.contains(e.relatedTarget);
              this.cache.disclosureList.classList.contains(t.listVisible) &&
                !i &&
                this._hideList();
            },
            _onDisclosureKeyUp: function (e) {
              27 === e.which &&
                (this._hideList(), this.cache.disclosureToggle.focus());
            },
            _onBodyClick: function (e) {
              var i = this.container.contains(e.target);
              this.cache.disclosureList.classList.contains(t.listVisible) &&
                !i &&
                this._hideList();
            },
            _submitForm: function (e) {
              (this.cache.disclosureInput.value = e),
                this.cache.disclosureForm.submit();
            },
            _hideList: function () {
              this.cache.disclosureList.classList.remove(t.listVisible),
                this.cache.disclosureToggle.setAttribute("aria-expanded", !1);
            },
            _toggleList: function () {
              var e =
                "true" ===
                this.cache.disclosureToggle.getAttribute("aria-expanded");
              this.cache.disclosureList.classList.toggle(t.listVisible),
                this.cache.disclosureToggle.setAttribute("aria-expanded", !e);
            },
            destroy: function () {
              this.cache.disclosureToggle.removeEventListener(
                "click",
                this.eventHandlers.toggleList
              ),
                this.cache.disclosureOptions.forEach(function (e) {
                  e.removeEventListener(
                    "click",
                    this.eventHandlers.connectOptions
                  );
                }, this),
                this.container.removeEventListener(
                  "keyup",
                  this.eventHandlers.onDisclosureKeyUp
                ),
                this.cache.disclosureList.removeEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureListFocusOut
                ),
                this.cache.disclosureToggle.removeEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureToggleFocusOut
                ),
                document.body.removeEventListener(
                  "click",
                  this.eventHandlers.onBodyClick
                );
            },
          })),
          i
        );
      })()),
      (theme.Drawers = (function () {
        function e(e, t) {
          (this.config = {
            id: e,
            close: ".js-drawer-close",
            open: ".js-drawer-open-" + t,
            openClass: "js-drawer-open",
            closingClass: "js-drawer-closing",
            activeDrawer: "drawer--is-open",
            namespace: ".drawer-" + t,
          }),
            (this.nodes = { page: document.querySelector("#MainContent") }),
            (this.drawer = document.querySelector("#" + e)),
            (this.isOpen = !1),
            this.drawer && this.init();
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            init: function () {
              document.querySelectorAll(this.config.open).forEach((e) => {
                e.setAttribute("aria-expanded", "false"),
                  e.addEventListener("click", this.open.bind(this));
              }),
                this.drawer
                  .querySelector(this.config.close)
                  .addEventListener("click", this.close.bind(this)),
                document.addEventListener(
                  "modalOpen",
                  function () {
                    this.close();
                  }.bind(this)
                );
            },
            open: function (e, t) {
              e && e.preventDefault(),
                !this.isOpen &&
                  (e && e.stopPropagation
                    ? (e.stopPropagation(),
                      e.currentTarget.setAttribute("aria-expanded", "true"),
                      (this.activeSource = e.currentTarget))
                    : t &&
                      (t.setAttribute("aria-expanded", "true"),
                      (this.activeSource = t)),
                  theme.utils.prepareTransition(
                    this.drawer,
                    function () {
                      this.drawer.classList.add(this.config.activeDrawer);
                    }.bind(this)
                  ),
                  document.documentElement.classList.add(this.config.openClass),
                  (this.isOpen = !0),
                  theme.a11y.trapFocus({
                    container: this.drawer,
                    namespace: "drawer_focus",
                  }),
                  document.dispatchEvent(new CustomEvent("drawerOpen")),
                  document.dispatchEvent(
                    new CustomEvent("drawerOpen." + this.config.id)
                  ),
                  this.bindEvents());
            },
            close: function (e) {
              if (this.isOpen) {
                if (e) {
                  if (e.target.closest(".js-drawer-close"));
                  else if (e.target.closest(".drawer")) return;
                }
                document.activeElement.blur(),
                  theme.utils.prepareTransition(
                    this.drawer,
                    function () {
                      this.drawer.classList.remove(this.config.activeDrawer);
                    }.bind(this)
                  ),
                  document.documentElement.classList.remove(
                    this.config.openClass
                  ),
                  document.documentElement.classList.add(
                    this.config.closingClass
                  ),
                  window.setTimeout(
                    function () {
                      document.documentElement.classList.remove(
                        this.config.closingClass
                      ),
                        this.activeSource &&
                          this.activeSource.getAttribute("aria-expanded") &&
                          (this.activeSource.setAttribute(
                            "aria-expanded",
                            "false"
                          ),
                          this.activeSource.focus());
                    }.bind(this),
                    500
                  ),
                  (this.isOpen = !1),
                  theme.a11y.removeTrapFocus({
                    container: this.drawer,
                    namespace: "drawer_focus",
                  }),
                  this.unbindEvents();
              }
            },
            bindEvents: function () {
              window.on(
                "click" + this.config.namespace,
                function (e) {
                  this.close(e);
                }.bind(this)
              ),
                window.on(
                  "keyup" + this.config.namespace,
                  function (e) {
                    27 === e.keyCode && this.close();
                  }.bind(this)
                ),
                theme.a11y.lockMobileScrolling(
                  this.config.namespace,
                  this.nodes.page
                );
            },
            unbindEvents: function () {
              window.off("click" + this.config.namespace),
                window.off("keyup" + this.config.namespace),
                theme.a11y.unlockMobileScrolling(
                  this.config.namespace,
                  this.nodes.page
                );
            },
          })),
          e
        );
      })()),
      (theme.Modals = (function () {
        function e(e, t, i) {
          if (
            ((this.id = e),
            (this.modal = document.getElementById(e)),
            !this.modal)
          )
            return !1;
          (this.modalContent = this.modal.querySelector(".modal__inner")),
            (this.config = Object.assign(
              {
                close: ".js-modal-close",
                open: ".js-modal-open-" + t,
                openClass: "modal--is-active",
                closingClass: "modal--is-closing",
                bodyOpenClass: ["modal-open"],
                bodyOpenSolidClass: "modal-open--solid",
                bodyClosingClass: "modal-closing",
                closeOffContentClick: !0,
              },
              i
            )),
            (this.modalIsOpen = !1),
            (this.focusOnOpen = this.config.focusIdOnOpen
              ? document.getElementById(this.config.focusIdOnOpen)
              : this.modal),
            (this.isSolid = this.config.solid),
            this.init();
        }
        return (
          (e.prototype.init = function () {
            document.querySelectorAll(this.config.open).forEach((e) => {
              e.setAttribute("aria-expanded", "false"),
                e.addEventListener("click", this.open.bind(this));
            }),
              this.modal.querySelectorAll(this.config.close).forEach((e) => {
                e.addEventListener("click", this.close.bind(this));
              }),
              document.addEventListener(
                "drawerOpen",
                function () {
                  this.close();
                }.bind(this)
              );
          }),
          (e.prototype.open = function (e) {
            var t = !1;
            !this.modalIsOpen &&
              (e ? e.preventDefault() : (t = !0),
              e &&
                e.stopPropagation &&
                (e.stopPropagation(),
                (this.activeSource = e.currentTarget.setAttribute(
                  "aria-expanded",
                  "true"
                ))),
              this.modalIsOpen && !t && this.close(),
              this.modal.classList.add(this.config.openClass),
              document.documentElement.classList.add(
                ...this.config.bodyOpenClass
              ),
              this.isSolid &&
                document.documentElement.classList.add(
                  this.config.bodyOpenSolidClass
                ),
              (this.modalIsOpen = !0),
              theme.a11y.trapFocus({
                container: this.modal,
                elementToFocus: this.focusOnOpen,
                namespace: "modal_focus",
              }),
              document.dispatchEvent(new CustomEvent("modalOpen")),
              document.dispatchEvent(new CustomEvent("modalOpen." + this.id)),
              this.bindEvents());
          }),
          (e.prototype.close = function (e) {
            if (this.modalIsOpen) {
              if (e) {
                if (e.target.closest(".js-modal-close"));
                else if (e.target.closest(".modal__inner")) return;
              }
              document.activeElement.blur(),
                this.modal.classList.remove(this.config.openClass),
                this.modal.classList.add(this.config.closingClass),
                document.documentElement.classList.remove(
                  ...this.config.bodyOpenClass
                ),
                document.documentElement.classList.add(
                  this.config.bodyClosingClass
                ),
                window.setTimeout(
                  function () {
                    document.documentElement.classList.remove(
                      this.config.bodyClosingClass
                    ),
                      this.modal.classList.remove(this.config.closingClass),
                      this.activeSource &&
                        this.activeSource.getAttribute("aria-expanded") &&
                        this.activeSource
                          .setAttribute("aria-expanded", "false")
                          .focus();
                  }.bind(this),
                  500
                ),
                this.isSolid &&
                  document.documentElement.classList.remove(
                    this.config.bodyOpenSolidClass
                  ),
                (this.modalIsOpen = !1),
                theme.a11y.removeTrapFocus({
                  container: this.modal,
                  namespace: "modal_focus",
                }),
                document.dispatchEvent(
                  new CustomEvent("modalClose." + this.id)
                ),
                this.unbindEvents();
            }
          }),
          (e.prototype.bindEvents = function () {
            window.on(
              "keyup.modal",
              function (e) {
                27 === e.keyCode && this.close();
              }.bind(this)
            ),
              this.config.closeOffContentClick &&
                this.modal.on("click.modal", this.close.bind(this));
          }),
          (e.prototype.unbindEvents = function () {
            document.documentElement.off(".modal"),
              this.config.closeOffContentClick && this.modal.off(".modal");
          }),
          e
        );
      })()),
      (window.onpageshow = function (e) {
        e.persisted &&
          (document.body.classList.remove("unloading"),
          document.querySelectorAll(".cart__checkout").forEach((e) => {
            e.classList.remove("btn--loading");
          }));
      }),
      (theme.pageTransitions = function () {
        "true" === document.body.dataset.transitions &&
          (navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) &&
            document.querySelectorAll("a").forEach((e) => {
              window.setTimeout(function () {
                document.body.classList.remove("unloading");
              }, 1200);
            }),
          document
            .querySelectorAll(
              'a[href*="#"], a[class*="jdgm"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[download]'
            )
            .forEach((e) => {
              e.classList.add("js-no-transition");
            }),
          document
            .querySelectorAll(
              "a:not(.js-no-transition, .jdgm-paginate__page, .jdgm-star, .jdgm-rev__body-read-more)"
            )
            .forEach((e) => {
              e.addEventListener("click", function (t) {
                if (t.metaKey) return !0;
                t.preventDefault(), document.body.classList.add("unloading");
                var i = e.getAttribute("href");
                window.setTimeout(function () {
                  location.href = i;
                }, 50);
              });
            }),
          document.querySelectorAll("a.mobile-nav__link").forEach((e) => {
            e.addEventListener("click", function () {
              theme.NavDrawer.close();
            });
          }));
      }),
      (theme.parallaxSections = {}),
      (theme.Parallax = (function () {
        var e = !1;
        function t(e, t) {
          (this.isInit = !1),
            (this.isVisible = !1),
            (this.container = e),
            (this.image = e.querySelector(".parallax-image")),
            (this.namespace = t.namespace),
            (this.desktopOnly = t.desktopOnly),
            this.container &&
              this.image &&
              (this.desktopOnly &&
                (document.addEventListener(
                  "matchSmall",
                  function () {
                    this.destroy();
                  }.bind(this)
                ),
                document.addEventListener(
                  "unmatchSmall",
                  function () {
                    this.init(!0);
                  }.bind(this)
                )),
              this.init(this.desktopOnly));
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function (e) {
              this.isInit && this.destroy(),
                (this.isInit = !0),
                (!e || !theme.config.bpSmall) &&
                  (this.setSizes(),
                  this.scrollHandler(),
                  new IntersectionObserver(
                    (e, t) => {
                      e.forEach((e) => {
                        (this.isVisible = e.isIntersecting),
                          this.isVisible
                            ? window.on(
                                "scroll" + this.namespace,
                                this.onScroll.bind(this)
                              )
                            : window.off("scroll" + this.namespace);
                      });
                    },
                    { rootMargin: "200px 0px 200px 0px" }
                  ).observe(this.container),
                  window.on(
                    "resize" + this.namespace,
                    theme.utils.debounce(250, this.setSizes.bind(this))
                  ),
                  document.addEventListener(
                    "shopify:section:reorder",
                    theme.utils.debounce(250, this.onReorder.bind(this))
                  ));
            },
            onScroll: function () {
              this.isVisible &&
                (window.SPR && !e && (this.setSizes(), (e = !0)),
                requestAnimationFrame(this.scrollHandler.bind(this)));
            },
            scrollHandler: function () {
              var e = (window.scrollY - this.elTop) * 0.85;
              this.image.style.transform = "translate3d(0, " + e + "px, 0)";
            },
            setSizes: function () {
              var e = this.container.getBoundingClientRect();
              this.elTop = e.top + window.scrollY;
            },
            onReorder: function () {
              this.setSizes(), this.onScroll();
            },
            destroy: function () {
              (this.image.style.transform = "none"),
                window.off("scroll" + this.namespace),
                window.off("resize" + this.namespace);
            },
          })),
          t
        );
      })()),
      void 0 === window.noUiSlider)
    )
      throw Error(
        "theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js"
      );
    (theme.PriceRange = (function () {
      var e = {
        priceRange: ".price-range",
        priceRangeSlider: ".price-range__slider",
        priceRangeInputMin: ".price-range__input-min",
        priceRangeInputMax: ".price-range__input-max",
        priceRangeDisplayMin: ".price-range__display-min",
        priceRangeDisplayMax: ".price-range__display-max",
      };
      function t(e, { onChange: t, onUpdate: i, ...n } = {}) {
        return (
          (this.container = e),
          (this.onChange = t),
          (this.onUpdate = i),
          (this.sliderOptions = n || {}),
          this.init()
        );
      }
      return (
        (t.prototype = Object.assign({}, t.prototype, {
          init: function () {
            if (!this.container.classList.contains("price-range"))
              throw Error(
                "You must instantiate PriceRange with a valid container"
              );
            return (
              (this.formEl = this.container.closest("form")),
              (this.sliderEl = this.container.querySelector(
                e.priceRangeSlider
              )),
              (this.inputMinEl = this.container.querySelector(
                e.priceRangeInputMin
              )),
              (this.inputMaxEl = this.container.querySelector(
                e.priceRangeInputMax
              )),
              (this.displayMinEl = this.container.querySelector(
                e.priceRangeDisplayMin
              )),
              (this.displayMaxEl = this.container.querySelector(
                e.priceRangeDisplayMax
              )),
              (this.minRange = parseFloat(this.container.dataset.min) || 0),
              (this.minValue =
                parseFloat(this.container.dataset.minValue) || 0),
              (this.maxRange = parseFloat(this.container.dataset.max) || 100),
              (this.maxValue =
                parseFloat(this.container.dataset.maxValue) || this.maxRange),
              this.createPriceRange()
            );
          },
          createPriceRange: function () {
            this.sliderEl &&
              this.sliderEl.noUiSlider &&
              "function" == typeof this.sliderEl.noUiSlider.destroy &&
              this.sliderEl.noUiSlider.destroy();
            var e = noUiSlider.create(this.sliderEl, {
              connect: !0,
              step: 10,
              ...this.sliderOptions,
              start: [this.minValue, this.maxValue],
              range: { min: this.minRange, max: this.maxRange },
            });
            return (
              e.on("update", (e) => {
                (this.displayMinEl.innerHTML = theme.Currency.formatMoney(
                  e[0],
                  theme.settings.moneyFormat
                )),
                  (this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
                    e[1],
                    theme.settings.moneyFormat
                  )),
                  this.onUpdate && this.onUpdate(e);
              }),
              e.on("change", (e) => {
                if (
                  ((this.inputMinEl.value = e[0]),
                  (this.inputMaxEl.value = e[1]),
                  this.onChange)
                ) {
                  let t = new FormData(this.formEl);
                  this.onChange(t);
                }
              }),
              e
            );
          },
        })),
        t
      );
    })()),
      (theme.AjaxProduct = (function () {
        var e = { loading: !1 };
        function t(e, t, i) {
          (this.form = e),
            (this.args = i),
            this.form &&
              ((this.addToCart = e.querySelector(t || ".add-to-cart")),
              this.form.addEventListener(
                "submit",
                this.addItemFromForm.bind(this)
              ));
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            addItemFromForm: function (t, i) {
              if ((t.preventDefault(), !e.loading)) {
                this.addToCart.classList.add("btn--loading"), (e.loading = !0);
                var n = theme.utils.serialize(this.form);
                fetch(theme.routes.cartAdd, {
                  method: "POST",
                  body: n,
                  credentials: "same-origin",
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                })
                  .then((e) => e.json())
                  .then(
                    function (t) {
                      422 === t.status ? this.error(t) : this.success(t),
                        (e.loading = !1),
                        this.addToCart.classList.remove("btn--loading"),
                        document.body.classList.contains("template-cart") &&
                          (window.scrollTo(0, 0), location.reload());
                    }.bind(this)
                  );
              }
            },
            success: function (e) {
              var t = this.form.querySelector(".errors");
              t && t.remove(),
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: { product: e, addToCartBtn: this.addToCart },
                  })
                ),
                this.args &&
                  this.args.scopedEventId &&
                  document.dispatchEvent(
                    new CustomEvent(
                      "ajaxProduct:added:" + this.args.scopedEventId,
                      { detail: { product: e, addToCartBtn: this.addToCart } }
                    )
                  );
            },
            error: function (e) {
              if (!e.description) {
                console.warn(e);
                return;
              }
              var t = this.form.querySelector(".errors");
              t && t.remove();
              var i = document.createElement("div");
              i.classList.add("errors", "text-center"),
                (i.textContent = e.description),
                this.form.append(i),
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:error", {
                    detail: { errorMessage: e.description },
                  })
                ),
                this.args &&
                  this.args.scopedEventId &&
                  document.dispatchEvent(
                    new CustomEvent(
                      "ajaxProduct:error:" + this.args.scopedEventId,
                      { detail: { errorMessage: e.description } }
                    )
                  );
            },
          })),
          t
        );
      })()),
      (theme.ProductMedia = (function () {
        var e = {},
          t = {},
          i = {},
          n = {
            mediaGroup: "[data-product-single-media-group]",
            xrButton: "[data-shopify-xr]",
          };
        function s(e) {
          if (!e) {
            for (var i in t)
              if (t.hasOwnProperty(i)) {
                var n = t[i];
                !n.modelViewerUi &&
                  Shopify &&
                  (n.modelViewerUi = new Shopify.ModelViewerUI(n.element)),
                  a(n);
              }
          }
        }
        function a(e) {
          var t = i[e.sectionId];
          e.container.addEventListener("mediaVisible", function () {
            t.element.setAttribute("data-shopify-model3d-id", e.modelId),
              theme.config.isTouch || e.modelViewerUi.play();
          }),
            e.container.addEventListener("mediaHidden", function () {
              t.element.setAttribute("data-shopify-model3d-id", t.defaultId),
                e.modelViewerUi.pause();
            }),
            e.container.addEventListener("xrLaunch", function () {
              e.modelViewerUi.pause();
            });
        }
        return {
          init: function a(o, r) {
            (e[r] = { loaded: !1 }),
              o.forEach(function (e, s) {
                var a = e.dataset.mediaId,
                  o = e.querySelector("model-viewer"),
                  c = o.dataset.modelId;
                if (0 === s) {
                  var l = e.closest(n.mediaGroup).querySelector(n.xrButton);
                  i[r] = { element: l, defaultId: c };
                }
                t[a] = { modelId: c, sectionId: r, container: e, element: o };
              }),
              window.Shopify.loadFeatures([
                {
                  name: "shopify-xr",
                  version: "1.0",
                  onLoad: function t(i) {
                    if (!i) {
                      if (!window.ShopifyXR) {
                        document.addEventListener(
                          "shopify_xr_initialized",
                          function () {
                            t();
                          }
                        );
                        return;
                      }
                      for (var n in e)
                        if (e.hasOwnProperty(n)) {
                          var s = e[n];
                          if (s.loaded) continue;
                          var a = document.querySelector("#ModelJson-" + n);
                          window.ShopifyXR.addModels(JSON.parse(a.innerHTML)),
                            (s.loaded = !0);
                        }
                      window.ShopifyXR.setupXRElements();
                    }
                  },
                },
                { name: "model-viewer-ui", version: "1.0", onLoad: s },
              ]),
              theme.LibraryLoader.load("modelViewerUiStyles");
          },
          removeSectionModels: function i(n) {
            for (var s in t)
              t.hasOwnProperty(s) && t[s].sectionId === n && delete t[s];
            delete e[n];
          },
        };
      })()),
      (theme.QtySelector = (function () {
        var e = {
          input: ".js-qty__num",
          plus: ".js-qty__adjust--plus",
          minus: ".js-qty__adjust--minus",
        };
        function t(t, i) {
          (this.wrapper = t),
            (this.plus = t.querySelector(e.plus)),
            (this.minus = t.querySelector(e.minus)),
            (this.input = t.querySelector(e.input)),
            (this.minValue = this.input.getAttribute("min") || 1);
          var n = { namespace: null, isCart: !1, key: this.input.dataset.id };
          (this.options = Object.assign({}, n, i)), this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.plus.addEventListener(
                "click",
                function () {
                  var e = this._getQty();
                  this._change(e + 1);
                }.bind(this)
              ),
                this.minus.addEventListener(
                  "click",
                  function () {
                    var e = this._getQty();
                    this._change(e - 1);
                  }.bind(this)
                ),
                this.input.addEventListener(
                  "change",
                  function (e) {
                    this._change(this._getQty());
                  }.bind(this)
                );
            },
            _getQty: function () {
              var e = this.input.value;
              return (
                (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1),
                parseInt(e)
              );
            },
            _change: function (e) {
              e <= this.minValue && (e = this.minValue),
                (this.input.value = e),
                this.options.isCart &&
                  document.dispatchEvent(
                    new CustomEvent("cart:quantity" + this.options.namespace, {
                      detail: [this.options.key, e, this.wrapper],
                    })
                  );
            },
          })),
          t
        );
      })()),
      (theme.initQuickShop = function () {
        var e = document.querySelectorAll(".grid-product");
        function t(e) {
          var i = e.currentTarget;
          if (!theme.config.bpSmall) {
            if (
              (i.removeEventListener("mouseover", t),
              !i || !i.dataset.productId)
            )
              return;
            var n = i.dataset.productId,
              s = i.dataset.productHandle,
              a = i.querySelector(".quick-product__btn");
            theme.preloadProductModal(s, n, a);
          }
        }
        e.length &&
          theme.settings.quickView &&
          e.forEach((e) => {
            e.addEventListener("mouseover", t);
          });
      }),
      (theme.preloadProductModal = function (e, t, i) {
        var n = document.getElementById("QuickShopHolder-" + e),
          s = theme.routes.home + "/products/" + e + "?view=modal";
        fetch((s = s.replace("//", "/")))
          .then(function (e) {
            return e.text();
          })
          .then(function (s) {
            var a = new DOMParser()
              .parseFromString(s, "text/html")
              .querySelector(
                '.product-section[data-product-handle="' + e + '"]'
              );
            n &&
              ((n.innerHTML = ""),
              n.append(a),
              new theme.Modals("QuickShopModal-" + t, "quick-modal-" + t),
              theme.sections.register("product", theme.Product, n),
              theme.collapsibles.init(),
              theme.videoModal(),
              i && i.classList.remove("quick-product__btn--not-ready"));
          });
      }),
      (theme.Slideshow = (function () {
        var e = {
            animateOut: "animate-out",
            isPaused: "is-paused",
            isActive: "is-active",
          },
          t = {
            allSlides: ".slideshow__slide",
            currentSlide: ".is-selected",
            wrapper: ".slideshow-wrapper",
            pauseButton: ".slideshow__pause",
          },
          i = {
            thumb: ".product__thumb-item:not(.hide)",
            links: ".product__thumb-item:not(.hide) a",
            arrow: ".product__thumb-arrow",
          },
          n = {
            adaptiveHeight: !1,
            autoPlay: !1,
            avoidReflow: !1,
            childNav: null,
            childNavScroller: null,
            childVertical: !1,
            dragThreshold: 7,
            fade: !1,
            friction: 0.8,
            initialIndex: 0,
            pageDots: !1,
            pauseAutoPlayOnHover: !1,
            prevNextButtons: !1,
            rightToLeft: theme.config.rtl,
            selectedAttraction: 0.14,
            setGallerySize: !0,
            wrapAround: !0,
          };
        function s(e, s) {
          if (
            ((this.el = e),
            (this.args = Object.assign({}, n, s)),
            (this.args.on = {
              ready: this.init.bind(this),
              change: this.slideChange.bind(this),
              settle: this.afterChange.bind(this),
            }),
            this.args.childNav &&
              ((this.childNavEls = this.args.childNav.querySelectorAll(
                i.thumb
              )),
              (this.childNavLinks = this.args.childNav.querySelectorAll(
                i.links
              )),
              (this.arrows = this.args.childNav.querySelectorAll(i.arrow)),
              this.childNavLinks.length && this.initChildNav()),
            this.args.avoidReflow &&
              (function e(t) {
                if (t.id) {
                  for (var i = t.firstChild; null != i && 3 == i.nodeType; )
                    i = i.nextSibling;
                  var n = document.createElement("style");
                  (n.innerHTML = `#${t.id} .flickity-viewport{height:${i.offsetHeight}px}`),
                    document.head.appendChild(n);
                }
              })(e),
            (this.slideshow = new Flickity(e, this.args)),
            this.args.autoPlay)
          ) {
            var a = e.closest(t.wrapper);
            (this.pauseBtn = a.querySelector(t.pauseButton)),
              this.pauseBtn &&
                this.pauseBtn.addEventListener(
                  "click",
                  this._togglePause.bind(this)
                );
          }
          window.on(
            "resize",
            theme.utils.debounce(
              300,
              function () {
                this.resize();
              }.bind(this)
            )
          );
        }
        return (
          (s.prototype = Object.assign({}, s.prototype, {
            init: function (e) {
              (this.currentSlide = this.el.querySelector(t.currentSlide)),
                this.args.callbacks &&
                  this.args.callbacks.onInit &&
                  "function" == typeof this.args.callbacks.onInit &&
                  this.args.callbacks.onInit(this.currentSlide),
                window.AOS && AOS.refresh();
            },
            slideChange: function (t) {
              this.args.fade &&
                this.currentSlide &&
                (this.currentSlide.classList.add(e.animateOut),
                this.currentSlide.addEventListener(
                  "transitionend",
                  function () {
                    this.currentSlide.classList.remove(e.animateOut);
                  }.bind(this)
                )),
                this.args.childNav && this.childNavGoTo(t),
                this.args.callbacks &&
                  this.args.callbacks.onChange &&
                  "function" == typeof this.args.callbacks.onChange &&
                  this.args.callbacks.onChange(t),
                this.arrows &&
                  this.arrows.length &&
                  (this.arrows[0].classList.toggle("hide", 0 === t),
                  this.arrows[1].classList.toggle(
                    "hide",
                    t === this.childNavLinks.length - 1
                  ));
            },
            afterChange: function (i) {
              this.args.fade &&
                this.el.querySelectorAll(t.allSlides).forEach((t) => {
                  t.classList.remove(e.animateOut);
                }),
                (this.currentSlide = this.el.querySelector(t.currentSlide)),
                this.args.childNav &&
                  this.childNavGoTo(this.slideshow.selectedIndex);
            },
            destroy: function () {
              this.args.childNav &&
                this.childNavLinks.length &&
                this.childNavLinks.forEach((t) => {
                  t.classList.remove(e.isActive);
                }),
                this.slideshow.destroy();
            },
            reposition: function () {
              this.slideshow.reposition();
            },
            _togglePause: function () {
              this.pauseBtn.classList.contains(e.isPaused)
                ? (this.pauseBtn.classList.remove(e.isPaused),
                  this.slideshow.playPlayer())
                : (this.pauseBtn.classList.add(e.isPaused),
                  this.slideshow.pausePlayer());
            },
            resize: function () {
              this.slideshow.resize();
            },
            play: function () {
              this.slideshow.playPlayer();
            },
            pause: function () {
              this.slideshow.pausePlayer();
            },
            goToSlide: function (e) {
              this.slideshow.select(e);
            },
            setDraggable: function (e) {
              (this.slideshow.options.draggable = e),
                this.slideshow.updateDraggable();
            },
            initChildNav: function () {
              this.childNavLinks[this.args.initialIndex].classList.add(
                "is-active"
              ),
                this.childNavLinks.forEach((e, t) => {
                  e.setAttribute("data-index", t),
                    e.addEventListener(
                      "click",
                      function (e) {
                        e.preventDefault(),
                          this.goToSlide(this.getChildIndex(e.currentTarget));
                      }.bind(this)
                    ),
                    e.addEventListener(
                      "focus",
                      function (e) {
                        this.goToSlide(this.getChildIndex(e.currentTarget));
                      }.bind(this)
                    ),
                    e.addEventListener(
                      "keydown",
                      function (e) {
                        13 === e.keyCode &&
                          this.goToSlide(this.getChildIndex(e.currentTarget));
                      }.bind(this)
                    );
                }),
                this.arrows.length &&
                  this.arrows.forEach((e) => {
                    e.addEventListener("click", this.arrowClick.bind(this));
                  });
            },
            getChildIndex: function (e) {
              return parseInt(e.dataset.index);
            },
            childNavGoTo: function (t) {
              this.childNavLinks.forEach((t) => {
                t.blur(), t.classList.remove(e.isActive);
              });
              var i = this.childNavLinks[t];
              if ((i.classList.add(e.isActive), this.args.childNavScroller)) {
                if (this.args.childVertical) {
                  var n = i.offsetTop;
                  this.args.childNavScroller.scrollTop = n - 100;
                } else {
                  var s = i.offsetLeft;
                  this.args.childNavScroller.scrollLeft = s - 100;
                }
              }
            },
            arrowClick: function (e) {
              e.currentTarget.classList.contains("product__thumb-arrow--prev")
                ? this.slideshow.previous()
                : this.slideshow.next();
            },
          })),
          s
        );
      })()),
      (theme.VariantAvailability = (function () {
        var e = { disabled: "disabled" };
        function t(e) {
          (this.type = e.type),
            (this.variantsObject = e.variantsObject),
            (this.currentVariantObject = e.currentVariantObject),
            (this.container = e.container),
            (this.namespace = e.namespace),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.container.on(
                "variantChange" + this.namespace,
                this.setAvailability.bind(this)
              ),
                this.setInitialAvailability();
            },
            createAvailableOptionsTree: (e, t) =>
              e.reduce(
                (e, i) => (
                  Object.keys(e).forEach((n) => {
                    if (null === i[n]) return;
                    let s = e[n].find((e) => e.value === i[n]);
                    void 0 === s &&
                      ((s = { value: i[n], soldOut: !0 }), e[n].push(s));
                    let a = t.find(({ value: e, index: t }) => "option1" === t),
                      o = t.find(({ value: e, index: t }) => "option2" === t);
                    switch (n) {
                      case "option1":
                        s.soldOut = (!s.soldOut || !i.available) && s.soldOut;
                        break;
                      case "option2":
                        a &&
                          i.option1 === a.value &&
                          (s.soldOut =
                            (!s.soldOut || !i.available) && s.soldOut);
                      case "option3":
                        a &&
                          i.option1 === a.value &&
                          o &&
                          i.option2 === o.value &&
                          (s.soldOut =
                            (!s.soldOut || !i.available) && s.soldOut);
                    }
                  }),
                  e
                ),
                { option1: [], option2: [], option3: [] }
              ),
            setInitialAvailability: function () {
              this.container
                .querySelectorAll(".variant-input-wrap")
                .forEach((e) => {
                  this.disableVariantGroup(e);
                });
              let e = this.currentVariantObject.options.map((e, t) => ({
                  value: e,
                  index: `option${t + 1}`,
                })),
                t = this.createAvailableOptionsTree(
                  this.variantsObject,
                  e,
                  this.currentVariantObject
                );
              for (var [i, n] of Object.entries(t))
                this.manageOptionState(i, n);
            },
            setAvailability: function (e) {
              let {
                  value: t,
                  index: i,
                  currentlySelectedValues: n,
                  variant: s,
                } = e.detail,
                a = this.createAvailableOptionsTree(
                  this.variantsObject,
                  n,
                  s,
                  i,
                  t
                );
              for (var [o, r] of Object.entries(a))
                this.manageOptionState(o, r, t);
            },
            manageOptionState: function (e, t) {
              var i = this.container.querySelector(
                '.variant-input-wrap[data-index="' + e + '"]'
              );
              t.forEach((e) => {
                this.enableVariantOption(i, e);
              });
            },
            enableVariantOption: function (t, i) {
              var n = i.value.replace(
                /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
                "\\$1"
              );
              if ("dropdown" === this.type)
                t.querySelector('option[value="' + n + '"]').disabled = !1;
              else {
                var s = t.querySelector(
                    '.variant-input[data-value="' + n + '"]'
                  ),
                  a = s.querySelector("input"),
                  o = s.querySelector("label");
                a.classList.remove(e.disabled),
                  o.classList.remove(e.disabled),
                  i.soldOut &&
                    (a.classList.add(e.disabled), o.classList.add(e.disabled));
              }
            },
            disableVariantGroup: function (t) {
              "dropdown" === this.type
                ? t.querySelectorAll("option").forEach((e) => {
                    e.disabled = !0;
                  })
                : (t.querySelectorAll("input").forEach((t) => {
                    t.classList.add(e.disabled);
                  }),
                  t.querySelectorAll("label").forEach((t) => {
                    t.classList.add(e.disabled);
                  }));
            },
          })),
          t
        );
      })()),
      (theme.videoModal = function () {
        var e,
          t = "VideoHolder",
          i = {
            youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
            mp4Trigger: ".product-video-trigger--mp4",
            mp4Player: ".product-video-mp4-sound",
          },
          n = document.querySelectorAll(i.youtube),
          s = document.querySelectorAll(i.mp4Trigger);
        if (n.length || s.length) {
          var a = document.getElementById(t);
          n.length && theme.LibraryLoader.load("youtubeSdk");
          var o = new theme.Modals("VideoModal", "video-modal", {
            closeOffContentClick: !0,
            bodyOpenClass: ["modal-open", "video-modal-open"],
            solid: !0,
          });
          n.forEach((e) => {
            e.addEventListener("click", r);
          }),
            s.forEach((e) => {
              e.addEventListener("click", c);
            }),
            document.addEventListener("modalClose.VideoModal", function t() {
              e && "function" == typeof e.destroy ? e.destroy() : d();
            });
        }
        function r(i) {
          if (theme.config.youTubeReady) {
            i.preventDefault(), d(), o.open(i);
            var n,
              s,
              a =
                ((n = i.currentTarget.getAttribute("href")),
                (s = n.match(
                  /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
                )),
                !!s && 11 == s[7].length && s[7]);
            e = new theme.YouTube(t, {
              videoId: a,
              style: "sound",
              events: { onReady: l },
            });
          }
        }
        function c(e) {
          d();
          var t = e.currentTarget.parentNode
            .querySelector(i.mp4Player)
            .cloneNode(!0);
          t.classList.remove("hide"),
            a.append(t),
            o.open(e),
            a.querySelector("video").play();
        }
        function l(e) {
          e.target.unMute(), e.target.playVideo();
        }
        function d() {
          a.innerHTML = "";
        }
      });
    class c extends HTMLElement {
      constructor() {
        super(),
          (this.el = this),
          (this.inner = this.querySelector("[data-tool-tip-inner]")),
          (this.closeButton = this.querySelector("[data-tool-tip-close]")),
          (this.toolTipContent = this.querySelector("[data-tool-tip-content]")),
          (this.triggers = document.querySelectorAll(
            "[data-tool-tip-trigger]"
          )),
          document.addEventListener("tooltip:open", (e) => {
            this._open(e.detail.context, e.detail.content);
          });
      }
      _open(e, t) {
        (this.toolTipContent.innerHTML = t),
          theme.a11y.trapFocus({
            container: this.el,
            namespace: "tooltip_focus",
          }),
          this.closeButton &&
            this.closeButton.on("click.tooltip-close", () => {
              this._close();
            }),
          document.documentElement.on("click.tooltip-outerclick", (e) => {
            "true" !== this.el.dataset.toolTipOpen ||
              this.inner.contains(e.target) ||
              this._close();
          }),
          document.documentElement.on("keydown.tooltip-esc", (e) => {
            "Escape" === e.code && this._close();
          }),
          (this.el.dataset.toolTipOpen = !0),
          (this.el.dataset.toolTip = e);
      }
      _close() {
        (this.toolTipContent.innerHTML = ""),
          (this.el.dataset.toolTipOpen = "false"),
          (this.el.dataset.toolTip = ""),
          theme.a11y.removeTrapFocus({
            container: this.el,
            namespace: "tooltip_focus",
          }),
          this.closeButton.off("click.tooltip-close"),
          document.documentElement.off("click.tooltip-outerclick"),
          document.documentElement.off("keydown.tooltip-esc");
      }
    }
    customElements.define("tool-tip", c);
    class l extends HTMLElement {
      constructor() {
        super(),
          (this.el = this),
          (this.toolTipContent = this.querySelector("[data-tool-tip-content]")),
          this.init();
      }
      init() {
        let e = new CustomEvent("tooltip:open", {
          detail: {
            context: this.dataset.toolTip,
            content: this.toolTipContent.innerHTML,
          },
          bubbles: !0,
        });
        this.el.addEventListener("click", (t) => {
          t.stopPropagation(), this.dispatchEvent(e);
        });
      }
    }
    customElements.define("tool-tip-trigger", l);
    class d extends HTMLElement {
      constructor() {
        super(),
          (this.closeBtn = this.querySelector("[data-close-button]")),
          (this.popupTrigger = this.querySelector("[data-message]")),
          (this.id = this.dataset.sectionId),
          (this.newsletterId = `NewsletterPopup-${this.id}`),
          (this.cookie = Cookies.get(`newsletter-${this.id}`)),
          (this.cookieName = `newsletter-${this.id}`),
          (this.secondsBeforeShow = this.dataset.delaySeconds),
          (this.expiry = parseInt(this.dataset.delayDays)),
          (this.modal = new theme.Modals(
            `NewsletterPopup-${this.newsletterId}`,
            "newsletter-popup-modal"
          )),
          this.init();
      }
      init() {
        document.addEventListener("shopify:block:select", (e) => {
          e.detail.sectionId === this.id && this.show(0, !0);
        }),
          document.addEventListener("shopify:block:deselect", (e) => {
            e.detail.sectionId === this.id && this.hide();
          }),
          document.addEventListener(`modalOpen.${this.newsletterId}`, () =>
            this.hide()
          ),
          document.addEventListener(`modalClose.${this.newsletterId}`, () =>
            this.show()
          ),
          this.closeBtn.addEventListener("click", () => {
            this.hide(),
              Cookies.set(this.cookieName, "opened", {
                path: "/",
                expires: this.expiry,
              });
          }),
          this.popupTrigger.addEventListener("click", () => {
            let e = new CustomEvent("reminder:openNewsletter", { bubbles: !0 });
            this.dispatchEvent(e), this.hide();
          });
      }
      show(e = this.secondsBeforeShow, t = !1) {
        (!0 == !sessionStorage.getItem("newsletterAppeared") || t) &&
          setTimeout(() => {
            (this.dataset.enabled = "true"),
              t || sessionStorage.setItem("newsletterAppeared", !0);
          }, 1e3 * e);
      }
      hide() {
        this.dataset.enabled = "false";
      }
    }
    customElements.define("newsletter-reminder", d),
      (theme.buildProductGridItem = function (e, t) {
        var i = "";
        return (
          e.forEach((e) => {
            i += `
        <div class="grid__item ${t}">
          <a href="${e.url}" class="predictive__result">
            <div class="predictive__result-image">
              ${theme.buildPredictiveImage(e)}
            </div>
            <div class="predictive__result-meta">
              <div class="grid-product__title">
                ${e.title}
              </div>
            </div>
          </a>
        </div>
      `;
          }),
          i
        );
      }),
      (theme.buildCollectionItem = function (e) {
        var t = "";
        return (
          e.forEach((e) => {
            t += `
        <div class="grid__item medium-up--one-third">
          <a href="${e.url}" class="predictive__result">
            <div class="predictive__result-image">
              ${theme.buildPredictiveImage(e)}
            </div>
            <div class="predictive__result-meta">
              <div class="grid-product__title">
                ${e.title}
              </div>
            </div>
          </a>
        </div>
      `;
          }),
          t
        );
      }),
      (theme.buildPageItem = function (e) {
        var t = "";
        return (
          e.forEach((e) => {
            t += `
        <div>
          <a href="${e.url}">
            ${e.title}
          </a>
        </div>
      `;
          }),
          t
        );
      }),
      (theme.buildArticleItem = function (e) {
        var t = "";
        return (
          e.forEach((e) => {
            t += `
        <div class="grid__item medium-up--one-third">
          <a href="${e.url}" class="predictive__result">
            <div class="predictive__result-image">
              ${theme.buildPredictiveImage(e)}
            </div>
            <div class="predictive__result-meta">
              ${e.title}
            </div>
          </a>
        </div>
      `;
          }),
          t
        );
      }),
      (theme.buildPredictiveImage = function (e) {
        var t = "";
        return e.image && (t = `<img src="${e.image}" alt="${e.title}">`), t;
      }),
      (theme.announcementBar = (function () {
        var e = {
            bar: ".announcement",
            text: ".announcement__text",
            closeBtn: ".announcement__close",
          },
          t = {
            opening: "announcement--opening",
            closed: "announcement--closed",
          },
          i = { namespace: ".announcementBar" };
        function n() {
          document.querySelector(e.bar).classList.remove(t.closed), s();
        }
        function s() {
          var i = document.querySelector(e.text).clientHeight;
          document.querySelector(e.bar).classList.add(t.opening),
            (document.querySelector(e.bar).style.maxHeight = i + "px");
        }
        function a() {
          theme.config.hasSessionStorage &&
            sessionStorage.setItem(o(), "hidden"),
            document.querySelector(e.bar).classList.add(t.closed);
        }
        function o() {
          return document.querySelector(e.text).dataset.text;
        }
        return {
          init: function t() {
            document.querySelector(e.closeBtn) &&
              (theme.config.hasSessionStorage &&
                "hidden" !== sessionStorage[o()] &&
                window.setTimeout(function () {
                  n();
                }, 2e3),
              theme.config.hasSessionStorage ||
                window.setTimeout(function () {
                  n();
                }, 2e3),
              document.querySelector(e.closeBtn).addEventListener("click", a),
              window.on("resize" + i.namespace, theme.utils.debounce(500, s)));
          },
          unload: function e() {
            window.off("resize" + i.namespace);
          },
        };
      })()),
      (theme.articleImages = function () {
        var e = document.querySelectorAll(".rte--indented-images");
        e.length &&
          e.forEach((e) => {
            e.querySelectorAll("img").forEach((t) => {
              var i = t.getAttribute("style");
              (!i || "float: none;" == i) &&
                t.width < e.offsetWidth &&
                t.classList.add("rte__no-indent");
            });
          });
      }),
      (theme.CartDrawer = (function () {
        var e = { drawer: "#CartDrawer", form: "#CartDrawerForm" };
        function t() {
          (this.form = document.querySelector(e.form)),
            (this.drawer = new theme.Drawers("CartDrawer", "cart")),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              (this.cartForm = new theme.CartForm(this.form)),
                this.cartForm.buildCart(),
                document.addEventListener(
                  "ajaxProduct:added",
                  function (e) {
                    this.cartForm.buildCart(), this.open();
                  }.bind(this)
                ),
                document.addEventListener("cart:open", this.open.bind(this)),
                document.addEventListener("cart:close", this.close.bind(this));
            },
            open: function () {
              this.drawer.open();
            },
            close: function () {
              this.drawer.close();
            },
          })),
          t
        );
      })()),
      (theme.customerTemplates = function () {
        var e, t, i, n;
        function s() {
          document
            .getElementById("RecoverPasswordForm")
            .classList.toggle("hide"),
            document
              .getElementById("CustomerLoginForm")
              .classList.toggle("hide");
        }
        "#recover" === window.location.hash && s(),
          (e = document.getElementById("RecoverPassword")) &&
            e.addEventListener("click", function (e) {
              e.preventDefault(), s();
            }),
          (t = document.getElementById("HideRecoverPasswordLink")) &&
            t.addEventListener("click", function (e) {
              e.preventDefault(), s();
            }),
          document.querySelector(".reset-password-success") &&
            document.getElementById("ResetSuccess").classList.remove("hide"),
          (i = document.getElementById("AddressNewForm")),
          (n = document.querySelectorAll(".js-address-form")),
          i &&
            n.length &&
            (setTimeout(function () {
              document.querySelectorAll(".js-address-country").forEach((e) => {
                var t = e.dataset.countryId,
                  i = e.dataset.provinceId,
                  n = e.dataset.provinceContainerId;
                new Shopify.CountryProvinceSelector(t, i, { hideElement: n });
              });
            }, 1e3),
            document.querySelectorAll(".address-new-toggle").forEach((e) => {
              e.addEventListener("click", function () {
                i.classList.toggle("hide");
              });
            }),
            document.querySelectorAll(".address-edit-toggle").forEach((e) => {
              e.addEventListener("click", function (e) {
                var t = e.currentTarget.dataset.formId;
                document
                  .getElementById("EditAddress_" + t)
                  .classList.toggle("hide");
              });
            }),
            document.querySelectorAll(".address-delete").forEach((e) => {
              e.addEventListener("click", function (e) {
                var t = e.currentTarget.dataset.formId;
                confirm(
                  e.currentTarget.dataset.confirmMessage ||
                    "Are you sure you wish to delete this address?"
                ) &&
                  Shopify &&
                  Shopify.postLink("/account/addresses/" + t, {
                    parameters: { _method: "delete" },
                  });
              });
            }));
      }),
      (theme.headerNav = (function () {
        var e,
          t,
          i = {
            wrapper: "#HeaderWrapper",
            siteHeader: "#SiteHeader",
            searchBtn: ".js-search-header",
            closeSearch: "#SearchClose",
            searchContainer: ".site-header__search-container",
            logo: "#LogoContainer img",
            navItems: ".site-nav__item",
            navLinks: ".site-nav__link",
            navDropdown: ".site-nav__dropdown",
            navLinksWithDropdown: ".site-nav__link--has-dropdown",
            navDropdownLinks: ".site-nav__dropdown-link--second-level",
          },
          n = {
            hasDropdownClass: "site-nav--has-dropdown",
            hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
            dropdownActive: "is-focused",
          },
          s = {
            namespace: ".siteNav",
            wrapperOverlayed: !1,
            overlayedClass: "is-light",
            overlayEnabledClass: "header-wrapper--overlay",
            stickyEnabled: !1,
            stickyActive: !1,
            stickyClass: "site-header--stuck",
            stickyHeaderWrapper: "StickyHeaderWrap",
            openTransitionClass: "site-header--opening",
            lastScroll: 0,
          };
        function a() {
          if (s.stickyEnabled) {
            var e = t.offsetHeight;
            document.querySelector("#" + s.stickyHeaderWrapper).style.height =
              e + "px";
          }
        }
        function o() {
          s.stickyEnabled &&
            (requestAnimationFrame(r), (s.lastScroll = window.scrollY));
        }
        function r() {
          if (window.scrollY > 250)
            !s.stickyActive &&
              ((s.stickyActive = !0),
              t.classList.add(s.stickyClass),
              s.wrapperOverlayed && e.classList.remove(s.overlayedClass),
              setTimeout(function () {
                t.classList.add(s.openTransitionClass);
              }, 100));
          else {
            if (!s.stickyActive) return;
            (s.stickyActive = !1),
              t.classList.remove(s.openTransitionClass),
              t.classList.remove(s.stickyClass),
              s.wrapperOverlayed && e.classList.add(s.overlayedClass);
          }
        }
        function c(e) {
          e.preventDefault(), e.stopImmediatePropagation();
          var t = document.querySelector(i.searchContainer);
          theme.utils.prepareTransition(
            t,
            function () {
              t.classList.add("is-active");
            }.bind(this)
          ),
            document.documentElement.classList.add(
              "js-drawer-open",
              "js-drawer-open--search"
            ),
            setTimeout(function () {
              theme.a11y.trapFocus({
                container: t,
                namespace: "header_search",
                elementToFocus: t.querySelector(".site-header__search-input"),
              });
            }, 100),
            theme.config.bpSmall &&
              s.stickyEnabled &&
              s.lastScroll < 300 &&
              window.scrollTo(0, 0),
            theme.a11y.lockMobileScrolling(s.namespace),
            (function e() {
              window.on(
                "keyup" + s.namespace,
                function (e) {
                  27 === e.keyCode && l();
                }.bind(this)
              ),
                document.documentElement.on(
                  "click" + s.namespace,
                  function (e) {
                    l(e);
                  }.bind(this)
                );
            })();
        }
        function l(e) {
          if (e) {
            for (
              var t = e.path || (e.composedPath && e.composedPath()), n = 0;
              n < t.length;
              n++
            )
              if (t[n].classList) {
                if (t[n].classList.contains("site-header__search-btn")) break;
                if (t[n].classList.contains("site-header__search-container"))
                  return;
              }
          }
          document.activeElement.blur(),
            document.documentElement.classList.add("js-drawer-closing"),
            document.documentElement.classList.remove(
              "js-drawer-open",
              "js-drawer-open--search"
            ),
            window.setTimeout(
              function () {
                document.documentElement.classList.remove("js-drawer-closing");
              }.bind(this),
              500
            );
          var a = document.querySelector(i.searchContainer);
          theme.utils.prepareTransition(
            a,
            function () {
              a.classList.remove("is-active");
            }.bind(this)
          ),
            theme.a11y.removeTrapFocus({
              container: a,
              namespace: "header_search",
            }),
            theme.a11y.unlockMobileScrolling(s.namespace),
            window.off("keyup" + s.namespace),
            document.documentElement.off("click" + s.namespace);
        }
        function d(e) {
          document.querySelectorAll(i.logo).forEach((e) => {
            var t = e.clientWidth,
              i = e.closest(".header-item").clientWidth;
            t > i ? (e.style.maxWidth = i) : e.removeAttribute("style");
          });
        }
        return {
          init: function r() {
            var h;
            (e = document.querySelector(i.wrapper)),
              (t = document.querySelector(i.siteHeader)),
              (s.stickyEnabled = "true" === t.dataset.sticky),
              s.stickyEnabled &&
                ((s.wrapperOverlayed = e.classList.contains(s.overlayedClass)),
                (s.lastScroll = 0),
                ((h = document.createElement("div")).id =
                  s.stickyHeaderWrapper),
                theme.utils.wrap(t, h),
                a(),
                window.on("resize" + s.namespace, theme.utils.debounce(50, a)),
                window.on("scroll" + s.namespace, theme.utils.throttle(20, o)),
                Shopify &&
                  Shopify.designMode &&
                  setTimeout(function () {
                    a();
                  }, 250)),
              (theme.settings.overlayHeader = "true" === t.dataset.overlay),
              theme.settings.overlayHeader &&
                Shopify &&
                Shopify.designMode &&
                document.body.classList.contains("template-collection") &&
                !document.querySelector(".collection-hero") &&
                this.disableOverlayHeader(),
              (function e() {
                var a = !1,
                  o = !1,
                  r = !1;
                function c(e) {
                  a && u(), o && p(), l(e.currentTarget);
                }
                function l(e) {
                  var t = e.parentNode;
                  if (
                    (t.classList.contains(n.hasDropdownClass) &&
                      (t.classList.add(n.dropdownActive), (a = !0)),
                    !theme.config.isTouch && !r)
                  ) {
                    var i = theme.config.isTouch ? "touchend" : "click";
                    (r = !0),
                      document.documentElement.on(
                        i + s.namespace,
                        function () {
                          h(),
                            document.documentElement.off(i + s.namespace),
                            (r = !1);
                        }.bind(this)
                      );
                  }
                }
                function d(e, t) {
                  var i = e.parentNode;
                  (i.classList.contains(n.hasSubDropdownClass) || t) &&
                    (i.classList.add(n.dropdownActive), (o = !0));
                }
                function h() {
                  u(), p();
                }
                function u() {
                  document.querySelectorAll(i.navItems).forEach((e) => {
                    e.classList.remove(n.dropdownActive);
                  });
                }
                function p() {
                  document.querySelectorAll(i.navDropdownLinks).forEach((e) => {
                    e.parentNode.classList.remove(n.dropdownActive);
                  });
                }
                theme.config.isTouch &&
                  document
                    .querySelectorAll(i.navLinksWithDropdown)
                    .forEach((e) => {
                      e.on("touchend" + s.namespace, function (e) {
                        e.currentTarget.parentNode.classList.contains(
                          n.dropdownActive
                        )
                          ? window.location.replace(
                              e.currentTarget.getAttribute("href")
                            )
                          : (e.preventDefault(), h(), l(e.currentTarget));
                      });
                    }),
                  document.querySelectorAll(i.navLinks).forEach((e) => {
                    e.on("focusin" + s.namespace, c),
                      e.on("mouseover" + s.namespace, c),
                      e.on("mouseleave" + s.namespace, h);
                  }),
                  document.querySelectorAll(i.navDropdownLinks).forEach((e) => {
                    theme.config.isTouch &&
                      e.on("touchend" + s.namespace, function (e) {
                        var t = e.currentTarget.parentNode;
                        t.classList.contains(n.hasSubDropdownClass)
                          ? t.classList.contains(n.dropdownActive)
                            ? window.location.replace(
                                e.currentTarget.getAttribute("href")
                              )
                            : (e.preventDefault(), p(), d(e.currentTarget))
                          : window.location.replace(
                              e.currentTarget.getAttribute("href")
                            );
                      }),
                      e.on("focusin" + s.namespace, function (e) {
                        p(), d(e.currentTarget, !0);
                      });
                  }),
                  theme.config.isTouch &&
                    (document.body.on("touchend" + s.namespace, function () {
                      h();
                    }),
                    t.querySelectorAll(i.navDropdown).forEach((e) => {
                      e.on("touchend" + s.namespace, function (e) {
                        e.stopImmediatePropagation();
                      });
                    }));
              })(),
              document.querySelectorAll(i.searchBtn).forEach((e) => {
                e.addEventListener("click", c);
              }),
              document
                .querySelector(i.closeSearch)
                .addEventListener("click", l),
              window.on("load" + s.namespace, d),
              window.on("resize" + s.namespace, theme.utils.debounce(150, d));
          },
          disableOverlayHeader: function t() {
            e.classList.remove(s.overlayEnabledClass),
              e.classList.remove(s.overlayedClass),
              (s.wrapperOverlayed = !1);
          },
        };
      })()),
      (theme.predictiveSearch = (function () {
        var e,
          t = "",
          i = !1,
          n = ".predictive",
          s = {
            form: "#HeaderSearchForm",
            input: 'input[type="search"]',
            wrapper: "#PredictiveWrapper",
            resultDiv: "#PredictiveResults",
            searchButton: "[data-predictive-search-button]",
          },
          a = {},
          o = { up_arrow: 38, down_arrow: 40, tab: 9 };
        function r() {
          a.wrapper.classList.add("hide"),
            (a.results.innerHTML = ""),
            clearTimeout(e);
        }
        function c() {
          a.form.submit();
        }
        function l(e) {
          e.preventDefault ? e.preventDefault() : (e.returnValue = !1);
          var t = {},
            i = new FormData(e.target);
          for (var n of i.keys()) t[n] = i.get(n);
          t.q && (t.q += "*");
          var s = h(t);
          return (window.location.href = `${theme.routes.search}?${s}`), !1;
        }
        function d(n) {
          n.keyCode !== o.up_arrow &&
            n.keyCode !== o.down_arrow &&
            n.keyCode !== o.tab &&
            (function n() {
              var s = a.input.value;
              if ("" === s) {
                r();
                return;
              }
              var o,
                c =
                  ((o = s),
                  "string" != typeof o
                    ? null
                    : o.trim().replace(/\ /g, "-").toLowerCase());
              clearTimeout(e),
                (e = setTimeout(
                  function () {
                    (function e(n) {
                      if (!i && t !== n) {
                        var s;
                        (t = n),
                          (i = !0),
                          fetch(
                            "/search/suggest.json?" +
                              h({
                                q: n,
                                "resources[type]":
                                  theme.settings.predictiveSearchType,
                                "resources[limit]": 3,
                                "resources[options][unavailable_products]":
                                  "last",
                                "resources[options][fields]":
                                  "title,product_type,variants.title,vendor",
                              })
                          )
                            .then((e) => e.json())
                            .then((e) => {
                              i = !1;
                              var t = {},
                                n = 0;
                              a.wrapper.classList.remove("hide");
                              var s = Object.entries(e.resources.results);
                              if (
                                (Object.keys(s).forEach(function (e) {
                                  var i,
                                    a,
                                    o,
                                    r,
                                    c,
                                    l,
                                    d,
                                    h,
                                    u,
                                    p,
                                    f = s[e],
                                    m = f[0],
                                    g = f[1];
                                  switch (((n += g.length), m)) {
                                    case "products":
                                      t[m] =
                                        ((i = g),
                                        (a = ""),
                                        (o = []),
                                        i.forEach((e) => {
                                          var t = {
                                            title: e.title,
                                            url: e.url,
                                            image:
                                              theme.Images.getSizedImageUrl(
                                                e.image,
                                                "200x200_crop_center"
                                              ),
                                          };
                                          o.push(t);
                                        }),
                                        o.length &&
                                          (a = `
          <div data-type-products>
            <div class="grid grid--small">
              ${theme.buildProductGridItem(o, "medium-up--one-third")}
            </div>
          </div>
        `),
                                        a);
                                      break;
                                    case "collections":
                                      t[m] =
                                        ((r = g),
                                        (c = ""),
                                        (l = []),
                                        r.forEach((e) => {
                                          var t = {
                                            title: e.title,
                                            url: e.url,
                                          };
                                          e.featured_image.url &&
                                            (t.image =
                                              theme.Images.getSizedImageUrl(
                                                e.featured_image.url,
                                                "200x200_crop_center"
                                              )),
                                            l.push(t);
                                        }),
                                        l.length &&
                                          (c = `
          <div data-type-collections>
            <p class="h6 predictive__label">${
              theme.strings.searchCollections
            }</p>
            <div class="grid grid--small">
              ${theme.buildCollectionItem(l)}
            </div>
          </div>
        `),
                                        c);
                                      break;
                                    case "pages":
                                      t[m] =
                                        ((d = g),
                                        (h = ""),
                                        d.length &&
                                          (h = `
          <div data-type-pages>
            <p class="h6 predictive__label">${theme.strings.searchPages}</p>
            ${theme.buildPageItem(d)}
          </div>
        `),
                                        h);
                                      break;
                                    case "articles":
                                      t[m] =
                                        ((u = g),
                                        (p = ""),
                                        u.forEach((e) => {
                                          e.image &&
                                            (e.image =
                                              theme.Images.getSizedImageUrl(
                                                e.image,
                                                "200x200_crop_center"
                                              ));
                                        }),
                                        u.length &&
                                          (p = `
          <div data-type-articles>
            <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
            <div class="grid grid--uniform">
              ${theme.buildArticleItem(u)}
            </div>
          </div>
        `),
                                        p);
                                  }
                                }),
                                0 === n)
                              ) {
                                r();
                                return;
                              }
                              var o,
                                c,
                                l =
                                  ((o = t),
                                  (c = ""),
                                  o.products &&
                                    "" !== o.products &&
                                    (c += o.products),
                                  o.collections &&
                                    "" !== o.collections &&
                                    (c += o.collections),
                                  o.pages && "" !== o.pages && (c += o.pages),
                                  o.articles &&
                                    "" !== o.articles &&
                                    (c += o.articles),
                                  c);
                              (a.results.innerHTML = ""),
                                (a.results.innerHTML = l);
                            });
                      }
                    })(c);
                  }.bind(this),
                  500
                ));
            })();
        }
        function h(e) {
          return Object.keys(e)
            .map(function (t) {
              return t + "=" + encodeURIComponent(e[t]);
            })
            .join("&");
        }
        return {
          init: function e() {
            if (
              !document.getElementById("shopify-features") ||
              JSON.parse(document.getElementById("shopify-features").innerHTML)
                .predictiveSearch
            )
              (a.wrapper = document.querySelector(s.wrapper)),
                a.wrapper &&
                  ((a.form = document.querySelector(s.form)),
                  a.form.setAttribute("autocomplete", "off"),
                  a.form.on("submit" + n, l),
                  (a.input = a.form.querySelector(s.input)),
                  a.input.on("keyup" + n, d),
                  (a.submit = a.wrapper.querySelector(s.searchButton)),
                  a.submit.on("click" + n, c),
                  (a.results = document.querySelector(s.resultDiv)));
          },
        };
      })()),
      (theme.Maps = (function () {
        var e = { zoom: 14 },
          t = null,
          i = [],
          n = {},
          s = {
            section: '[data-section-type="map"]',
            map: "[data-map]",
            mapOverlay: ".map-section__overlay",
          };
        function a(e) {
          (this.container = e),
            (this.sectionId = this.container.getAttribute("data-section-id")),
            (this.namespace = ".map-" + this.sectionId),
            (this.map = e.querySelector(s.map)),
            (this.key = this.map.dataset.apiKey),
            (n = {
              addressNoResults: theme.strings.addressNoResults,
              addressQueryLimit: theme.strings.addressQueryLimit,
              addressError: theme.strings.addressError,
              authError: theme.strings.authError,
            }),
            this.key &&
              theme.initWhenVisible({
                element: this.container,
                callback: this.prepMapApi.bind(this),
                threshold: 20,
              });
        }
        return (
          (window.gm_authFailure = function () {
            Shopify.designMode &&
              (document.querySelectorAll(s.section).forEach((e) => {
                e.classList.add("map-section--load-error");
              }),
              document.querySelectorAll(s.map).forEach((e) => {
                e.parentNode.removeChild(e);
              }),
              window.mapError(theme.strings.authError));
          }),
          (window.mapError = function (e) {
            var t = document.createElement("div");
            t.classList.add("map-section__error", "errors", "text-center"),
              (t.innerHTML = e),
              document.querySelectorAll(s.mapOverlay).forEach((e) => {
                e.parentNode.prepend(t);
              }),
              document.querySelectorAll(".map-section__link").forEach((e) => {
                e.classList.add("hide");
              });
          }),
          (a.prototype = Object.assign({}, a.prototype, {
            prepMapApi: function () {
              if ("loaded" === t) this.createMap();
              else if (
                (i.push(this),
                "loading" !== t &&
                  ((t = "loading"),
                  void 0 === window.google || void 0 === window.google.maps))
              ) {
                var e = document.createElement("script");
                (e.onload = function () {
                  (t = "loaded"),
                    i.forEach((e) => {
                      e.createMap();
                    });
                }),
                  (e.src =
                    "https://maps.googleapis.com/maps/api/js?key=" + this.key),
                  document.head.appendChild(e);
              }
            },
            createMap: function () {
              var t = this.map;
              return (function e(t) {
                var i = new google.maps.Geocoder();
                if (t) {
                  var n = t.dataset.addressSetting;
                  return new Promise((e, t) => {
                    i.geocode({ address: n }, function (i, n) {
                      n !== google.maps.GeocoderStatus.OK && t(n), e(i);
                    });
                  });
                }
              })(t)
                .then(
                  function (i) {
                    var n = {
                        zoom: e.zoom,
                        backgroundColor: "none",
                        center: i[0].geometry.location,
                        draggable: !1,
                        clickableIcons: !1,
                        scrollwheel: !1,
                        disableDoubleClickZoom: !0,
                        disableDefaultUI: !0,
                      },
                      s = (this.map = new google.maps.Map(t, n)),
                      a = (this.center = s.getCenter());
                    new google.maps.Marker({ map: s, position: s.getCenter() }),
                      google.maps.event.addDomListener(
                        window,
                        "resize",
                        theme.utils.debounce(250, function () {
                          google.maps.event.trigger(s, "resize"),
                            s.setCenter(a),
                            t.removeAttribute("style");
                        })
                      ),
                      Shopify.designMode && window.AOS && AOS.refreshHard();
                  }.bind(this)
                )
                .catch(function (e) {
                  var t;
                  switch (e) {
                    case "ZERO_RESULTS":
                      t = n.addressNoResults;
                      break;
                    case "OVER_QUERY_LIMIT":
                      t = n.addressQueryLimit;
                      break;
                    case "REQUEST_DENIED":
                      t = n.authError;
                      break;
                    default:
                      t = n.addressError;
                  }
                  Shopify.designMode && window.mapError(t);
                });
            },
            onUnload: function () {
              0 !== this.map.length &&
                google &&
                google.maps &&
                google.maps.event &&
                google.maps.event.clearListeners(this.map, "resize");
            },
          })),
          a
        );
      })()),
      (theme.NewsletterPopup = (function () {
        function e(e) {
          this.container = e;
          var t = this.container.getAttribute("data-section-id");
          if (
            ((this.cookieName = "newsletter-" + t),
            (this.cookie = Cookies.get(this.cookieName)),
            e &&
              "/challenge" !== window.location.pathname &&
              "/password" !== window.location.pathname)
          ) {
            (this.data = {
              secondsBeforeShow: e.dataset.delaySeconds,
              daysBeforeReappear: e.dataset.delayDays,
              hasReminder: e.dataset.hasReminder,
              testMode: e.dataset.testMode,
              isEnabled: e.dataset.enabled,
            }),
              (this.modal = new theme.Modals(
                "NewsletterPopup-" + t,
                "newsletter-popup-modal"
              ));
            var i = e.querySelector(".popup-cta a");
            if (
              (i &&
                i.addEventListener(
                  "click",
                  function () {
                    this.closePopup(!0);
                  }.bind(this)
                ),
              (e.querySelector(".errors") ||
                e.querySelector(".note--success")) &&
                this.modal.open(),
              e.querySelector(".note--success"))
            ) {
              this.closePopup(!0);
              return;
            }
            document.addEventListener(
              "modalClose." + e.id,
              this.closePopup.bind(this)
            ),
              this.cookie ||
                "true" !== this.data.isEnabled ||
                this.initPopupDelay(),
              document.addEventListener("reminder:openNewsletter", () => {
                this.modal.open();
              });
          }
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            initPopupDelay: function () {
              "true" !== this.data.testMode &&
                setTimeout(
                  function () {
                    this.modal.open();
                  }.bind(this),
                  1e3 * this.data.secondsBeforeShow
                );
            },
            closePopup: function (e) {
              if ("true" === this.data.testMode) {
                Cookies.remove(this.cookieName, { path: "/" });
                return;
              }
              var t = e ? 200 : this.data.daysBeforeReappear,
                i = "true" === this.data.hasReminder,
                n = "true" === sessionStorage.getItem("newsletterAppeared");
              i && n
                ? Cookies.set(this.cookieName, "opened", {
                    path: "/",
                    expires: t,
                  })
                : i ||
                  Cookies.set(this.cookieName, "opened", {
                    path: "/",
                    expires: t,
                  });
            },
            onLoad: function () {
              this.modal.open();
            },
            onSelect: function () {
              this.modal.open();
            },
            onDeselect: function () {
              this.modal.close();
            },
            onBlockSelect: function () {
              this.modal.close();
            },
            onBlockDeselect: function () {
              this.modal.open();
            },
          })),
          e
        );
      })()),
      (theme.PasswordHeader = (function () {
        function e() {
          this.init();
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            init: function () {
              if (document.querySelector("#LoginModal")) {
                var e = new theme.Modals("LoginModal", "login-modal", {
                  focusIdOnOpen: "password",
                  solid: !0,
                });
                document.querySelectorAll(".errors").length && e.open();
              }
            },
          })),
          e
        );
      })()),
      (theme.Photoswipe = (function () {
        var e = {
          trigger: ".js-photoswipe__zoom",
          images: ".photoswipe__image",
          slideshowTrack: ".flickity-viewport ",
          activeImage: ".is-selected",
        };
        function t(e, t) {
          (this.container = e),
            (this.sectionId = t),
            (this.namespace = ".photoswipe-" + this.sectionId),
            this.gallery,
            this.images,
            this.items,
            (this.inSlideshow = !1),
            e && "false" !== e.dataset.zoom && this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.container.querySelectorAll(e.trigger).forEach((e) => {
                e.on("click" + this.namespace, this.triggerClick.bind(this));
              });
            },
            triggerClick: function (t) {
              this.container.dataset &&
              "true" === this.container.dataset.hasSlideshow
                ? (this.inSlideshow = !0)
                : (this.inSlideshow = !1),
                (this.items = this.getImageData());
              var i = this.inSlideshow
                  ? this.container.querySelector(e.activeImage)
                  : t.currentTarget,
                n = this.inSlideshow ? this.getChildIndex(i) : i.dataset.index;
              this.initGallery(this.items, n);
            },
            getChildIndex: function (e) {
              for (var t = 0; null != (e = e.previousSibling); ) t++;
              return t + 1;
            },
            getImageData: function () {
              this.images = this.inSlideshow
                ? this.container.querySelectorAll(e.slideshowTrack + e.images)
                : this.container.querySelectorAll(e.images);
              var t = [];
              return (
                this.images.forEach((e) => {
                  var i = {
                    msrc: e.currentSrc || e.src,
                    src: e.getAttribute("data-photoswipe-src"),
                    w: e.getAttribute("data-photoswipe-width"),
                    h: e.getAttribute("data-photoswipe-height"),
                    el: e,
                    initialZoomLevel: 0.5,
                  };
                  t.push(i);
                }),
                t
              );
            },
            initGallery: function (e, t) {
              var i = document.querySelectorAll(".pswp")[0];
              (this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, e, {
                allowPanToNext: !1,
                captionEl: !1,
                closeOnScroll: !1,
                counterEl: !1,
                history: !1,
                index: t - 1,
                pinchToClose: !1,
                preloaderEl: !1,
                scaleMode: "zoom",
                shareEl: !1,
                tapToToggleControls: !1,
                getThumbBoundsFn: function (t) {
                  var i =
                      window.pageYOffset || document.documentElement.scrollTop,
                    n = e[t].el.getBoundingClientRect();
                  return { x: n.left, y: n.top + i, w: n.width };
                },
              })),
                this.gallery.listen("afterChange", this.afterChange.bind(this)),
                this.gallery.init(),
                this.preventiOS15Scrolling();
            },
            afterChange: function () {
              var e = this.gallery.getCurrentIndex();
              this.container.dispatchEvent(
                new CustomEvent("photoswipe:afterChange", {
                  detail: { index: e },
                })
              );
            },
            syncHeight: function () {
              document.documentElement.style.setProperty(
                "--window-inner-height",
                `${window.innerHeight}px`
              );
            },
            preventiOS15Scrolling: function () {
              let e;
              /iPhone|iPad|iPod/i.test(window.navigator.userAgent) &&
                (this.syncHeight(),
                (e = window.scrollY),
                document.documentElement.classList.add("pswp-open-in-ios"),
                window.addEventListener("resize", this.syncHeight),
                this.gallery.listen("destroy", () => {
                  document.documentElement.classList.remove("pswp-open-in-ios"),
                    window.scrollTo(0, e);
                }));
            },
          })),
          t
        );
      })()),
      (theme.Recommendations = (function () {
        var e = {
          placeholder: ".product-recommendations-placeholder",
          sectionClass: " .product-recommendations",
          productResults: ".grid-product",
        };
        function t(t) {
          (this.container = t),
            (this.sectionId = t.getAttribute("data-section-id")),
            (this.url = t.dataset.url),
            (e.recommendations = "Recommendations-" + this.sectionId),
            theme.initWhenVisible({
              element: t,
              callback: this.init.bind(this),
              threshold: 500,
            });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = document.getElementById(e.recommendations);
              if (t && "false" !== t.dataset.enable) {
                var i = t.dataset.productId,
                  n = t.dataset.limit,
                  s =
                    this.url +
                    "?section_id=product-recommendations&limit=" +
                    n +
                    "&product_id=" +
                    i;
                if (Shopify.designMode) {
                  var a = t.querySelector(e.sectionClass);
                  a && (a.innerHTML = "");
                }
                fetch(s)
                  .then(function (e) {
                    return e.text();
                  })
                  .then(
                    function (i) {
                      var n = new DOMParser()
                          .parseFromString(i, "text/html")
                          .querySelector(e.sectionClass),
                        s = t.querySelector(e.placeholder);
                      if (s) {
                        if (((s.innerHTML = ""), !n)) {
                          this.container.classList.add("hide"),
                            AOS && AOS.refreshHard();
                          return;
                        }
                        s.appendChild(n),
                          theme.reinitProductGridItem(t),
                          document.dispatchEvent(
                            new CustomEvent("recommendations:loaded", {
                              detail: { section: t },
                            })
                          ),
                          0 === n.querySelectorAll(e.productResults).length &&
                            this.container.classList.add("hide");
                      }
                    }.bind(this)
                  );
              }
            },
          })),
          t
        );
      })()),
      (theme.SlideshowSection = (function () {
        var e = { parallaxContainer: ".parallax-container" };
        function t(e) {
          this.container = e;
          var t = e.getAttribute("data-section-id");
          if (
            ((this.slideshow = e.querySelector("#Slideshow-" + t)),
            (this.namespace = "." + t),
            (this.initialIndex = 0),
            this.slideshow)
          ) {
            var i = e.parentElement;
            0 === [].indexOf.call(i.parentElement.children, i)
              ? this.init()
              : theme.initWhenVisible({
                  element: this.container,
                  callback: this.init.bind(this),
                });
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = this.slideshow.querySelectorAll(".slideshow__slide");
              if (
                (this.container.hasAttribute("data-immediate-load")
                  ? (this.slideshow.classList.remove(
                      "loading",
                      "loading--delayed"
                    ),
                    this.slideshow.classList.add("loaded"))
                  : theme.loadImageSection(this.slideshow),
                t.length > 1)
              ) {
                var i = {
                  prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                  pageDots: this.slideshow.hasAttribute("data-dots"),
                  fade: !0,
                  setGallerySize: !1,
                  initialIndex: this.initialIndex,
                  autoPlay:
                    "true" === this.slideshow.dataset.autoplay &&
                    parseInt(this.slideshow.dataset.speed),
                };
                this.flickity = new theme.Slideshow(this.slideshow, i);
              } else t[0].classList.add("is-selected");
              this.container.hasAttribute("data-parallax") &&
                this.container.querySelectorAll(e.parallaxContainer).forEach(
                  function (e, t) {
                    new theme.Parallax(e, {
                      namespace: this.namespace + "-parallax-" + t,
                    });
                  }.bind(this)
                );
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (e) {
              var t = parseInt(
                this.slideshow.querySelector(
                  ".slideshow__slide--" + e.detail.blockId
                ).dataset.index
              );
              this.flickity && "function" == typeof this.flickity.pause
                ? (this.flickity.goToSlide(t), this.flickity.pause())
                : ((this.initialIndex = t),
                  setTimeout(
                    function () {
                      this.flickity &&
                        "function" == typeof this.flickity.pause &&
                        this.flickity.pause();
                    }.bind(this),
                    1e3
                  ));
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.args.autoPlay &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.StoreAvailability = (function () {
        var e = {
          drawerOpenBtn: ".js-drawer-open-availability",
          modalOpenBtn: ".js-modal-open-availability",
          productTitle: "[data-availability-product-title]",
        };
        function t(e) {
          (this.container = e),
            (this.baseUrl = e.dataset.baseUrl),
            (this.productTitle = e.dataset.productName);
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            updateContent: function (t) {
              var i =
                  this.baseUrl +
                  "/variants/" +
                  t +
                  "/?section_id=store-availability",
                n = this;
              fetch(i)
                .then(function (e) {
                  return e.text();
                })
                .then(function (t) {
                  if ("" === t.trim()) {
                    this.container.innerHTML = "";
                    return;
                  }
                  (n.container.innerHTML = t),
                    (n.container.innerHTML =
                      n.container.firstElementChild.innerHTML),
                    n.container.querySelector(e.drawerOpenBtn) &&
                      (n.drawer = new theme.Drawers(
                        "StoreAvailabilityDrawer",
                        "availability"
                      )),
                    n.container.querySelector(e.modalOpenBtn) &&
                      (n.modal = new theme.Modals(
                        "StoreAvailabilityModal",
                        "availability"
                      ));
                  var i = n.container.querySelector(e.productTitle);
                  i && (i.textContent = n.productTitle);
                });
            },
          })),
          t
        );
      })()),
      (theme.VideoSection = (function () {
        var e = { videoParent: ".video-parent-section" };
        function t(e) {
          (this.container = e),
            (this.sectionId = e.getAttribute("data-section-id")),
            (this.namespace = ".video-" + this.sectionId),
            this.videoObject,
            theme.initWhenVisible({
              element: this.container,
              callback: this.init.bind(this),
              threshold: 500,
            });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var e = this.container.querySelector(".video-div");
              if (e) {
                var t = e.dataset.type;
                switch (t) {
                  case "youtube":
                    var i = e.dataset.videoId;
                    this.initYoutubeVideo(i);
                    break;
                  case "vimeo":
                    var i = e.dataset.videoId;
                    this.initVimeoVideo(i);
                    break;
                  case "mp4":
                    this.initMp4Video();
                }
              }
            },
            initYoutubeVideo: function (t) {
              this.videoObject = new theme.YouTube(
                "YouTubeVideo-" + this.sectionId,
                { videoId: t, videoParent: e.videoParent }
              );
            },
            initVimeoVideo: function (t) {
              this.videoObject = new theme.VimeoPlayer(
                "Vimeo-" + this.sectionId,
                t,
                { videoParent: e.videoParent }
              );
            },
            initMp4Video: function () {
              var t = "Mp4Video-" + this.sectionId,
                i = document.getElementById(t),
                n = i.closest(e.videoParent);
              if (i) {
                n.classList.add("loaded");
                var s = document.querySelector("#" + t).play();
                void 0 !== s &&
                  s
                    .then(function () {})
                    .catch(function () {
                      i.setAttribute("controls", ""),
                        n.classList.add("video-interactable");
                    });
              }
            },
            onUnload: function (e) {
              e.target.id.replace("shopify-section-", ""),
                this.videoObject &&
                  "function" == typeof this.videoObject.destroy &&
                  this.videoObject.destroy();
            },
          })),
          t
        );
      })()),
      (theme.BackgroundImage = (function () {
        var e = { parallaxContainer: ".parallax-container" };
        function t(e) {
          if (((this.container = e), e)) {
            var t = e.getAttribute("data-section-id");
            (this.namespace = "." + t),
              theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
              });
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              if (this.container.dataset && this.container.dataset.parallax) {
                var t = this.container.querySelector(e.parallaxContainer),
                  i = { namespace: this.namespace, desktopOnly: !0 };
                theme.parallaxSections[this.namespace] = new theme.Parallax(
                  t,
                  i
                );
              }
            },
            onUnload: function (e) {
              this.container &&
                (theme.parallaxSections[this.namespace] &&
                  "function" ==
                    typeof theme.parallaxSections[this.namespace].destroy &&
                  theme.parallaxSections[this.namespace].destroy(),
                delete theme.parallaxSections[this.namespace]);
            },
          })),
          t
        );
      })()),
      (theme.Blog = (function () {
        function e(e) {
          this.tagFilters();
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            tagFilters: function () {
              var e = document.getElementById("BlogTagFilter");
              e &&
                e.addEventListener("change", function () {
                  location.href = e.value;
                });
            },
          })),
          e
        );
      })()),
      (theme.CollectionSwitcher = (function () {
        var e = {
            trigger: ".collection-switcher__trigger",
            collection: ".collection-switcher__collection",
            slider: ".collection-switcher__collection-grid",
          },
          t = {
            adaptiveHeight: !0,
            avoidReflow: !0,
            autoPlay: !1,
            cellAlign: "left",
            fade: !1,
            prevNextButtons: !0,
            setGallerySize: !0,
            wrapAround: !1,
          };
        function i(t) {
          (this.container = t),
            (this.sectionId = this.container.getAttribute("data-section-id")),
            (this.slideshows = t.querySelectorAll(e.slider)),
            (this.namespace = ".switcher-" + this.sectionId),
            (this.flickity = {}),
            (this.activeIndex = 0),
            theme.initWhenVisible({
              element: this.container,
              callback: this.init.bind(this),
              threshold: 300,
            });
        }
        return (
          (i.prototype = Object.assign({}, i.prototype, {
            init: function () {
              this.container.querySelectorAll(e.trigger),
                this.container.querySelectorAll(e.trigger).forEach((e) => {
                  e.on("click", this.switch.bind(this));
                }),
                this.slideshows.length &&
                  ((this.config = {
                    perRow: this.container.getAttribute("data-per-row"),
                    perRowMobile: 2,
                  }),
                  this.initSliders(),
                  document.addEventListener(
                    "matchSmall",
                    function () {
                      this.initSliders();
                    }.bind(this)
                  ),
                  document.addEventListener(
                    "unmatchSmall",
                    function () {
                      this.initSliders();
                    }.bind(this)
                  ));
            },
            initSliders: function () {
              this.container.querySelectorAll(e.collection).forEach((e) => {
                e.classList.remove("hide");
              }),
                (t.groupCells = theme.config.bpSmall
                  ? this.config.perRowMobile
                  : this.config.perRow),
                this.slideshows.forEach(
                  function (i, n) {
                    this.flickity[n] &&
                      "function" == typeof this.flickity[n].destroy &&
                      this.flickity[n].destroy(),
                      (this.flickity[n] = new theme.Slideshow(i, t)),
                      n !== this.activeIndex &&
                        i.closest(e.collection).classList.add("hide");
                  }.bind(this)
                ),
                AOS && AOS.refresh();
            },
            switch: function (t) {
              t.preventDefault();
              var i = t.currentTarget.getAttribute("aria-controls"),
                n = document.getElementById(i);
              (this.activeIndex = parseInt(n.dataset.index)),
                this.container.querySelectorAll(e.trigger).forEach((e) => {
                  e.classList.remove("is-active");
                }),
                t.currentTarget.classList.add("is-active"),
                this.container.querySelectorAll(e.collection).forEach((e) => {
                  e.classList.add("hide");
                }),
                n.classList.remove("hide"),
                this.flickity[this.activeIndex] &&
                  "function" == typeof this.flickity[this.activeIndex].resize &&
                  this.flickity[this.activeIndex].resize();
            },
            destroy: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onUnload: function () {
              this.destroy();
            },
          })),
          i
        );
      })()),
      (theme.CollectionSidebar = (function () {
        var e = { sidebar: "#CollectionSidebar" };
        function t(t) {
          this.container = t.querySelector(e.sidebar);
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.container &&
                (this.onUnload(),
                (theme.FilterDrawer = new theme.Drawers(
                  "FilterDrawer",
                  "collection-filters",
                  !0
                )));
            },
            forceReload: function () {
              this.init();
            },
            onSelect: function () {
              theme.FilterDrawer &&
                (drawerStyle || theme.config.bpSmall) &&
                theme.FilterDrawer.open();
            },
            onDeselect: function () {
              theme.FilterDrawer && theme.FilterDrawer.close();
            },
            onUnload: function () {
              theme.FilterDrawer && theme.FilterDrawer.close();
            },
          })),
          t
        );
      })()),
      (theme.Collection = (function () {
        var e = !1,
          t = !1,
          i = {
            sortSelect: "#SortBy",
            hero: ".collection-hero",
            title: ".collection-title",
            parallaxContainer: ".parallax-container",
            sidebar: "#CollectionSidebar",
            activeTagList: ".tag-list--active-tags",
            tags: ".tag-list input",
            activeTags: ".tag-list a",
            tagsForm: ".filter-form",
            filters: ".collection-filter",
            filterSidebar: ".collapsible-content--sidebar",
            trigger: ".collapsible-trigger",
            priceRange: ".price-range",
          },
          n = {
            activeTag: "tag--active",
            removeTagParent: "tag--remove",
            filterSidebar: "collapsible-content--sidebar",
            isOpen: "is-open",
          };
        function s(e) {
          (this.container = e),
            (this.sectionId = e.getAttribute("data-section-id")),
            (this.namespace = ".collection-" + this.sectionId);
          var n = e.querySelector(".collection-hero");
          if (n) {
            if (
              (t && this.checkIfNeedReload(),
              theme.loadImageSection(n),
              e.dataset && e.dataset.parallax)
            ) {
              var s = e.querySelector(i.parallaxContainer),
                a = { namespace: this.namespace };
              theme.parallaxSections[this.namespace] = new theme.Parallax(s, a);
            }
          } else
            theme.settings.overlayHeader &&
              theme.headerNav.disableOverlayHeader();
          (this.sidebar = new theme.CollectionSidebar(e)),
            (this.ajaxRenderer = new theme.AjaxRenderer({
              sections: [
                {
                  sectionId: this.sectionId,
                  nodeId: [
                    "CollectionAjaxContent",
                    "FilterDrawerTrigger",
                    "FilterDrawer",
                  ],
                },
              ],
              onReplace: this.onReplaceAjaxContent.bind(this),
            })),
            this.init();
        }
        return (
          (s.prototype = Object.assign({}, s.prototype, {
            init: function () {
              this.bindBackButton(),
                this.sidebar.init(),
                (this.sortSelect = this.container.querySelector(i.sortSelect)),
                this.sortSelect &&
                  ((this.defaultSort = this.getDefaultSortValue()),
                  this.sortSelect.addEventListener(
                    "change",
                    this.onSortChange.bind(this)
                  )),
                this.initPriceRange(),
                document.querySelectorAll(i.activeTags).forEach((e) => {
                  e.addEventListener("click", this.onTagClick.bind(this));
                }),
                document.querySelectorAll(i.tagsForm).forEach((e) => {
                  e.addEventListener("input", this.onFormSubmit.bind(this));
                }),
                (t = !0);
            },
            onTagClick: function (t) {
              let i = t.currentTarget;
              if (i.classList.contains("no-ajax") || (t.preventDefault(), e))
                return;
              e = !0;
              let n = i.parentNode,
                s = new URL(i.href);
              this.renderActiveTag(n, i),
                this.startLoading(),
                this.renderCollectionPage(s.searchParams);
            },
            onFormSubmit: function (t) {
              let i = t.target;
              if (i.classList.contains("no-ajax") || (t.preventDefault(), e))
                return;
              e = !0;
              let n = i.closest("li"),
                s = i.closest("form"),
                a = new FormData(s);
              this.renderActiveTag(n, i),
                this.startLoading(),
                this.renderFromFormData(a);
            },
            renderActiveTag: function (e, t) {
              let s = e.querySelector(".tag-text");
              e.classList.contains(n.activeTag)
                ? e.classList.remove(n.activeTag)
                : (e.classList.add(n.activeTag),
                  t.closest("li").classList.contains(n.removeTagParent)
                    ? e.remove()
                    : document
                        .querySelectorAll(i.activeTagList)
                        .forEach((e) => {
                          let t = document.createElement("li"),
                            i = document.createElement("a");
                          t.classList.add("tag", "tag--remove"),
                            i.classList.add("btn", "btn--small"),
                            (i.innerText = s.innerText),
                            t.appendChild(i),
                            e.appendChild(t);
                        }));
            },
            renderFromFormData: function (e) {
              let t = new URLSearchParams(e);
              this.renderCollectionPage(t);
            },
            renderCollectionPage: function (t, i = !0) {
              this.ajaxRenderer
                .renderPage(window.location.pathname, t, i)
                .then(() => {
                  document.dispatchEvent(
                    new CustomEvent("collection:reloaded")
                  ),
                    (e = !1);
                });
            },
            initPriceRange: function () {
              let e = document.querySelectorAll(i.priceRange);
              e.forEach(
                (e) =>
                  new theme.PriceRange(e, {
                    onChange: this.renderFromFormData.bind(this),
                  })
              );
            },
            getSortValue: function () {
              return this.sortSelect.value || this.defaultSort;
            },
            getDefaultSortValue: function () {
              return this.sortSelect.getAttribute("data-default-sortby");
            },
            onSortChange: function () {
              (this.queryParams = new URLSearchParams(window.location.search)),
                this.queryParams.set("sort_by", this.getSortValue()),
                this.queryParams.delete("page"),
                (window.location.search = this.queryParams.toString());
            },
            fetchOpenCollasibleFilters: function () {
              return Array.from(
                document.querySelectorAll(
                  `${i.sidebar} ${i.trigger}.${n.isOpen}`
                )
              ).map((e) => e.dataset.collapsibleId);
            },
            onReplaceAjaxContent: function (e, t) {
              let i = this.fetchOpenCollasibleFilters();
              if (
                (i.forEach((t) => {
                  e.querySelectorAll(`[data-collapsible-id=${t}]`).forEach(
                    this.openCollapsible
                  );
                }),
                "string" == typeof t.nodeId)
              ) {
                var n = e.getElementById(t.nodeId);
                if (!n) return;
                document.getElementById(t.nodeId).innerHTML = n.innerHTML;
              } else
                t.nodeId.forEach((t) => {
                  document.getElementById(t).innerHTML =
                    e.getElementById(t).innerHTML;
                });
              this.reInit(e);
            },
            openCollapsible: function (e) {
              e.classList.contains(n.filterSidebar) &&
                (e.style.height = "auto"),
                e.classList.add(n.isOpen);
            },
            reInit: function (e) {
              for (var t = 0; t < theme.sections.instances.length; t++) {
                var n = theme.sections.instances[t];
                "collection-template" === n.type && n.forceReload();
              }
              var s = e.querySelector(i.title);
              e &&
                s &&
                (document.querySelector(i.title).innerText = s.innerText),
                this.initPriceRange(),
                theme.reinitProductGridItem();
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            checkIfNeedReload: function () {
              Shopify.designMode &&
                theme.settings.overlayHeader &&
                (document
                  .querySelector(".header-wrapper")
                  .classList.contains("header-wrapper--overlay") ||
                  location.reload());
            },
            onUnload: function () {
              theme.parallaxSections[this.namespace] &&
                (theme.parallaxSections[this.namespace].destroy(),
                delete theme.parallaxSections[this.namespace]);
            },
            bindBackButton: function () {
              window.off("popstate" + this.namespace),
                window.on(
                  "popstate" + this.namespace,
                  function (e) {
                    if (e) {
                      let t = new URL(window.location.href);
                      this.renderCollectionPage(t.searchParams, !1);
                    }
                  }.bind(this)
                );
            },
            startLoading: function () {
              this.container.querySelectorAll(".grid-product").forEach((e) => {
                e.classList.add("unload");
              });
            },
          })),
          s
        );
      })()),
      (theme.FadingImages = (function () {
        var e = {
          activeImage: "active-image",
          finishedImage: "finished-image",
          activeTitles: "active-titles",
          finishedTitles: "finished-titles",
          compensation: "compensation",
        };
        function t(e) {
          this.container = e;
          var t = e.getAttribute("data-section-id");
          (this.namespace = ".fading-images-" + t),
            e &&
              (this.imageInterval,
              this.titleInterval,
              (this.data = {
                interval: e.dataset.interval,
                block_count: e.dataset.count,
                finish_interval: 1e3,
                timer_offset: 400,
                active_image: 1,
                active_title: 1,
                removed_compensation: !1,
              }),
              theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
              }));
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var e = this.container.querySelector(".fading-images");
              theme.loadImageSection(e),
                (this.allTitles = this.container.querySelectorAll(
                  ".fading-images-overlay__titles"
                )),
                new IntersectionObserver(
                  (e, t) => {
                    e.forEach((e) => {
                      e.isIntersecting
                        ? (this.startImages(), this.startTitles())
                        : (clearInterval(this.imageInterval),
                          clearInterval(this.titleInterval));
                    });
                  },
                  { rootMargin: "0px 0px 0px 0px" }
                ).observe(this.container);
            },
            nextImage: function () {
              var t = this.container.querySelector(
                '.fading-images__item[data-slide-index="' +
                  this.data.active_image +
                  '"]'
              );
              this.data.removed_compensation ||
                (t.classList.remove(e.compensation),
                (this.data.removed_compensation = !0)),
                t.classList.remove(e.activeImage),
                t.classList.add(e.finishedImage),
                this.data.active_image,
                window.setTimeout(function () {
                  t.classList.remove(e.finishedImage);
                }, this.data.finish_interval),
                this.data.active_image++,
                this.data.active_image > this.data.block_count &&
                  (this.data.active_image = 1),
                this.container
                  .querySelector(
                    '.fading-images__item[data-slide-index="' +
                      this.data.active_image +
                      '"]'
                  )
                  .classList.add(e.activeImage);
            },
            nextTitle: function () {
              this.allTitles.forEach((t) => {
                t.classList.remove(e.activeTitles),
                  t.classList.add(e.finishedTitles);
              }),
                this.data.active_title++,
                this.data.active_title > this.data.block_count &&
                  (this.data.active_title = 1);
              var t = this.data.active_title;
              window.setTimeout(
                function () {
                  var i = this.container.querySelector(
                      '.fading-images__item[data-slide-index="' + t + '"]'
                    ),
                    n = i.getAttribute("data-slide-title1"),
                    s = i.getAttribute("data-slide-title2");
                  this.container.querySelector(
                    ".fading-images-overlay__title--1"
                  ).textContent = n;
                  var a = this.container.querySelector(
                    ".fading-images-overlay__title--2"
                  );
                  a && (a.textContent = s),
                    this.allTitles.forEach((t) => {
                      t.classList.remove(e.finishedTitles),
                        t.classList.add(e.activeTitles);
                    });
                }.bind(this),
                this.data.finish_interval - 200
              );
            },
            startImages: function () {
              var t = this.container.querySelector(
                '.fading-images__item[data-slide-index="' +
                  this.data.active_image +
                  '"]'
              );
              t.classList.add(e.activeImage),
                t.classList.add(e.compensation),
                window.setTimeout(
                  function () {
                    this.imageInterval = setInterval(
                      this.nextImage.bind(this),
                      this.data.interval
                    );
                  }.bind(this),
                  this.data.timer_offset
                );
            },
            startTitles: function () {
              var t = this.data.active_title;
              window.setTimeout(
                function () {
                  var i = this.container.querySelector(
                      '.fading-images__item[data-slide-index="' + t + '"]'
                    ),
                    n = i.getAttribute("data-slide-title1"),
                    s = i.getAttribute("data-slide-title2");
                  this.container.querySelector(
                    ".fading-images-overlay__title--1"
                  ).textContent = n;
                  var a = this.container.querySelector(
                    ".fading-images-overlay__title--2"
                  );
                  a && (a.textContent = s),
                    this.allTitles.forEach((t) => {
                      t.classList.add(e.activeTitles);
                    });
                }.bind(this),
                750
              ),
                (this.titleInterval = setInterval(
                  this.nextTitle.bind(this),
                  this.data.interval
                ));
            },
          })),
          t
        );
      })()),
      (theme.FooterSection = (function () {
        var e = { locale: "FooterLocale", currency: "FooterCurrency" };
        function t(e) {
          (this.container = e),
            (this.localeDisclosure = null),
            (this.currencyDisclosure = null),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = document.getElementById(e.locale),
                i = document.getElementById(e.currency);
              t && (this.localeDisclosure = new theme.Disclosure(t)),
                i && (this.currencyDisclosure = new theme.Disclosure(i)),
                theme.collapsibles.init(this.container);
            },
            onUnload: function () {
              this.localeDisclosure && this.localeDisclosure.destroy(),
                this.currencyDisclosure && this.currencyDisclosure.destroy();
            },
          })),
          t
        );
      })()),
      (theme.HeaderSection = (function () {
        function e(e) {
          this.init();
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            init: function () {
              if (Shopify && Shopify.designMode)
                for (var e = 0; e < theme.sections.instances.length; e++) {
                  var t = theme.sections.instances[e];
                  "slideshow-section" === t.type && t.forceReload();
                }
              theme.headerNav.init(),
                theme.announcementBar.init(),
                this.initDrawers();
            },
            initDrawers: function () {
              (theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")),
                "drawer" !== theme.settings.cartType ||
                  document.body.classList.contains("template-cart") ||
                  new theme.CartDrawer(),
                theme.collapsibles.init(document.getElementById("NavDrawer"));
            },
            onUnload: function () {
              theme.NavDrawer.close(), theme.announcementBar.unload();
            },
          })),
          e
        );
      })()),
      (theme.Product = (function () {
        var e = {},
          t = {
            onSale: "sale-price",
            disabled: "disabled",
            isModal: "is-modal",
            loading: "loading",
            loaded: "loaded",
            hidden: "hide",
            interactable: "video-interactable",
            visuallyHide: "visually-invisible",
          },
          i = {
            productVideo: ".product__video",
            videoParent: ".product__video-wrapper",
            slide: ".product-main-slide",
            currentSlide: ".is-selected",
            startingSlide: ".starting-slide",
            variantType: ".variant-wrapper",
            blocks: "[data-product-blocks]",
            blocksHolder: "[data-blocks-holder]",
          };
        function n(e) {
          this.container = e;
          var t = (this.sectionId = e.getAttribute("data-section-id")),
            i = (this.productId = e.getAttribute("data-product-id"));
          (this.inModal = "true" === e.dataset.modal),
            this.modal,
            (this.settings = {
              enableHistoryState: e.dataset.history || !1,
              namespace: ".product-" + t,
              inventory: !1,
              inventoryThreshold: 10,
              modalInit: !1,
              hasImages: !0,
              imageSetName: null,
              imageSetIndex: null,
              currentImageSet: null,
              imageSize: "620x",
              currentSlideIndex: 0,
              videoLooping: e.dataset.videoLooping,
            }),
            this.inModal &&
              ((this.settings.enableHistoryState = !1),
              (this.settings.namespace = ".product-" + t + "-modal"),
              (this.modal = document.getElementById("QuickShopModal-" + i))),
            (this.selectors = {
              variantsJson: "[data-variant-json]",
              currentVariantJson: "[data-current-variant-json]",
              form: ".product-single__form",
              media: "[data-product-media-type-model]",
              closeMedia: ".product-single__close-media",
              photoThumbs: "[data-product-thumb]",
              thumbSlider: "[data-product-thumbs]",
              thumbScroller: ".product__thumbs--scroller",
              mainSlider: "[data-product-photos]",
              imageContainer: "[data-product-images]",
              productImageMain: "[data-product-image-main]",
              priceWrapper: "[data-product-price-wrap]",
              price: "[data-product-price]",
              comparePrice: "[data-compare-price]",
              priceA11y: "[data-a11y-price]",
              comparePriceA11y: "[data-compare-price-a11y]",
              unitWrapper: "[data-unit-price-wrapper]",
              unitPrice: "[data-unit-price]",
              unitPriceBaseUnit: "[data-unit-base]",
              sku: "[data-sku]",
              inventory: "[data-product-inventory]",
              incomingInventory: "[data-incoming-inventory]",
              colorLabel: "[data-variant-color-label]",
              addToCart: "[data-add-to-cart]",
              addToCartText: "[data-add-to-cart-text]",
              originalSelectorId: "[data-product-select]",
              singleOptionSelector: "[data-variant-input]",
              variantColorSwatch: ".variant__input--color-swatch",
              availabilityContainer: "[data-store-availability-holder]",
            }),
            this.cacheElements(),
            (this.firstProductImage =
              this.cache.mainSlider.querySelector("img")),
            this.firstProductImage || (this.settings.hasImages = !1);
          var n = this.cache.mainSlider.querySelector("[data-set-name]");
          n && (this.settings.imageSetName = n.dataset.setName), this.init();
        }
        return (
          (n.prototype = Object.assign({}, n.prototype, {
            init: function () {
              this.inModal &&
                (this.container.classList.add(t.isModal),
                document.addEventListener(
                  "modalOpen.QuickShopModal-" + this.productId,
                  this.openModalProduct.bind(this)
                ),
                document.addEventListener(
                  "modalClose.QuickShopModal-" + this.productId,
                  this.closeModalProduct.bind(this)
                )),
                this.inModal ||
                  (this.formSetup(),
                  this.productSetup(),
                  this.videoSetup(),
                  this.initProductSlider(),
                  this.customMediaListners());
            },
            cacheElements: function () {
              this.cache = {
                form: this.container.querySelector(this.selectors.form),
                mainSlider: this.container.querySelector(
                  this.selectors.mainSlider
                ),
                thumbSlider: this.container.querySelector(
                  this.selectors.thumbSlider
                ),
                thumbScroller: this.container.querySelector(
                  this.selectors.thumbScroller
                ),
                productImageMain: this.container.querySelector(
                  this.selectors.productImageMain
                ),
                priceWrapper: this.container.querySelector(
                  this.selectors.priceWrapper
                ),
                comparePriceA11y: this.container.querySelector(
                  this.selectors.comparePriceA11y
                ),
                comparePrice: this.container.querySelector(
                  this.selectors.comparePrice
                ),
                price: this.container.querySelector(this.selectors.price),
                priceA11y: this.container.querySelector(
                  this.selectors.priceA11y
                ),
              };
            },
            onUnload: function () {
              theme.ProductMedia.removeSectionModels(this.sectionId),
                this.flickity &&
                  "function" == typeof this.flickity.destroy &&
                  this.flickity.destroy();
            },
            formSetup: function () {
              this.initQtySelector(),
                this.initAjaxProductForm(),
                this.availabilitySetup(),
                this.initVariants();
            },
            availabilitySetup: function () {
              var e = this.container.querySelector(
                this.selectors.availabilityContainer
              );
              e && (this.storeAvailability = new theme.StoreAvailability(e));
            },
            productSetup: function () {
              this.setImageSizes(),
                this.initImageZoom(),
                this.initModelViewerLibraries(),
                this.initShopifyXrLaunch(),
                theme.collapsibles.init(this.container),
                window.SPR && (SPR.initDomEls(), SPR.loadBadges());
            },
            setImageSizes: function () {
              if (this.settings.hasImages) {
                var e = this.firstProductImage.currentSrc;
                e && (this.settings.imageSize = theme.Images.imageSize(e));
              }
            },
            initVariants: function () {
              var e = this.container.querySelector(this.selectors.variantsJson);
              if (e) {
                this.variantsObject = JSON.parse(e.innerHTML);
                var t = {
                  container: this.container,
                  enableHistoryState: this.settings.enableHistoryState,
                  singleOptionSelector: this.selectors.singleOptionSelector,
                  originalSelectorId: this.selectors.originalSelectorId,
                  variants: this.variantsObject,
                };
                if (
                  ((this.variants = new theme.Variants(t)),
                  this.container
                    .querySelectorAll(this.selectors.variantColorSwatch)
                    .forEach((e) => {
                      e.addEventListener(
                        "change",
                        function (e) {
                          var t = e.currentTarget,
                            i = t.dataset.colorName,
                            n = t.dataset.colorIndex;
                          this.updateColorName(i, n);
                        }.bind(this)
                      );
                    }),
                  this.storeAvailability)
                ) {
                  var n = this.variants.currentVariant
                    ? this.variants.currentVariant.id
                    : this.variants.variants[0].id;
                  this.storeAvailability.updateContent(n),
                    this.container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateAvailability.bind(this)
                    );
                }
                this.container.on(
                  "variantChange" + this.settings.namespace,
                  this.updateCartButton.bind(this)
                ),
                  this.container.on(
                    "variantImageChange" + this.settings.namespace,
                    this.updateVariantImage.bind(this)
                  ),
                  this.container.on(
                    "variantPriceChange" + this.settings.namespace,
                    this.updatePrice.bind(this)
                  ),
                  this.container.on(
                    "variantUnitPriceChange" + this.settings.namespace,
                    this.updateUnitPrice.bind(this)
                  ),
                  this.container.querySelector(this.selectors.sku) &&
                    this.container.on(
                      "variantSKUChange" + this.settings.namespace,
                      this.updateSku.bind(this)
                    );
                var s = this.container.querySelector(this.selectors.inventory);
                if (
                  (s &&
                    ((this.settings.inventory = !0),
                    (this.settings.inventoryThreshold = s.dataset.threshold),
                    this.container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateInventory.bind(this)
                    )),
                  theme.settings.dynamicVariantsEnable)
                ) {
                  var a = this.container.querySelector(
                    this.selectors.currentVariantJson
                  );
                  if (a) {
                    var o = this.container.querySelector(i.variantType);
                    o &&
                      new theme.VariantAvailability({
                        container: this.container,
                        namespace: this.settings.namespace,
                        type: o.dataset.type,
                        variantsObject: this.variantsObject,
                        currentVariantObject: JSON.parse(a.innerHTML),
                      });
                  }
                }
                if (this.settings.imageSetName) {
                  var r = this.container.querySelector(
                    '.variant-input-wrap[data-handle="' +
                      this.settings.imageSetName +
                      '"]'
                  );
                  r
                    ? ((this.settings.imageSetIndex = r.dataset.index),
                      this.container.on(
                        "variantChange" + this.settings.namespace,
                        this.updateImageSet.bind(this)
                      ))
                    : (this.settings.imageSetName = null);
                }
              }
            },
            updateColorName: function (e, t) {
              this.container.querySelector(
                this.selectors.colorLabel + `[data-index="${t}"`
              ).textContent = e;
            },
            initQtySelector: function () {
              this.container
                .querySelectorAll(".js-qty__wrapper")
                .forEach((e) => {
                  new theme.QtySelector(e, { namespace: ".product" });
                });
            },
            initAjaxProductForm: function () {
              "drawer" === theme.settings.cartType &&
                new theme.AjaxProduct(this.cache.form);
            },
            updateCartButton: function (e) {
              var i = e.detail.variant,
                n = this.container.querySelector(this.selectors.addToCart),
                s = this.container.querySelector(this.selectors.addToCartText);
              if (i) {
                if (i.available) {
                  n.classList.remove(t.disabled), (n.disabled = !1);
                  var a = s.dataset.defaultText;
                  s.textContent = a;
                } else
                  n.classList.add(t.disabled),
                    (n.disabled = !0),
                    (s.textContent = theme.strings.soldOut);
              } else
                n.classList.add(t.disabled),
                  (n.disabled = !0),
                  (s.textContent = theme.strings.unavailable);
            },
            updatePrice: function (e) {
              var i = e.detail.variant;
              i &&
                ((this.cache.price.innerHTML = theme.Currency.formatMoney(
                  i.price,
                  theme.settings.moneyFormat
                )),
                i.compare_at_price > i.price
                  ? ((this.cache.comparePrice.innerHTML =
                      theme.Currency.formatMoney(
                        i.compare_at_price,
                        theme.settings.moneyFormat
                      )),
                    this.cache.priceWrapper.classList.remove(t.hidden),
                    this.cache.price.classList.add(t.onSale),
                    this.cache.comparePriceA11y.setAttribute(
                      "aria-hidden",
                      "false"
                    ),
                    this.cache.priceA11y.setAttribute("aria-hidden", "false"))
                  : (this.cache.priceWrapper &&
                      this.cache.priceWrapper.classList.add(t.hidden),
                    this.cache.price.classList.remove(t.onSale),
                    this.cache.comparePriceA11y &&
                      this.cache.comparePriceA11y.setAttribute(
                        "aria-hidden",
                        "true"
                      ),
                    this.cache.priceA11y.setAttribute("aria-hidden", "true")));
            },
            updateUnitPrice: function (e) {
              var i = e.detail.variant;
              i && i.unit_price
                ? ((this.container.querySelector(
                    this.selectors.unitPrice
                  ).innerHTML = theme.Currency.formatMoney(
                    i.unit_price,
                    theme.settings.moneyFormat
                  )),
                  (this.container.querySelector(
                    this.selectors.unitPriceBaseUnit
                  ).innerHTML = theme.Currency.getBaseUnit(i)),
                  this.container
                    .querySelector(this.selectors.unitWrapper)
                    .classList.remove(t.visuallyHide))
                : this.container
                    .querySelector(this.selectors.unitWrapper)
                    .classList.add(t.visuallyHide);
            },
            imageSetArguments: function (e) {
              var e =
                e || (this.variants ? this.variants.currentVariant : null);
              if (e) {
                var t = (this.settings.currentImageSet = this.getImageSetName(
                    e[this.settings.imageSetIndex]
                  )),
                  i = this.settings.imageSetName + "_" + t;
                return (
                  (this.settings.currentSlideIndex = 0),
                  {
                    cellSelector: '[data-group="' + i + '"]',
                    imageSet: i,
                    initialIndex: this.settings.currentSlideIndex,
                  }
                );
              }
            },
            updateImageSet: function (e) {
              var t = e
                ? e.detail.variant
                : this.variants
                ? this.variants.currentVariant
                : null;
              if (t) {
                var i = this.getImageSetName(t[this.settings.imageSetIndex]);
                this.settings.currentImageSet !== i &&
                  this.initProductSlider(t);
              }
            },
            updateImageSetThumbs: function (e) {
              this.cache.thumbSlider
                .querySelectorAll(".product__thumb-item")
                .forEach((i) => {
                  i.classList.toggle(t.hidden, i.dataset.group !== e);
                });
            },
            getImageSetName: function (e) {
              return e
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "");
            },
            updateSku: function (e) {
              var t = e.detail.variant,
                i = "";
              t &&
                (t.sku && (i = t.sku),
                (this.container.querySelector(this.selectors.sku).textContent =
                  i));
            },
            updateInventory: function (e) {
              var t = e.detail.variant;
              if (
                !t ||
                !t.inventory_management ||
                "continue" === t.inventory_policy
              ) {
                this.toggleInventoryQuantity(t, !1),
                  this.toggleIncomingInventory(!1);
                return;
              }
              if (
                "shopify" === t.inventory_management &&
                window.inventories &&
                window.inventories[this.productId]
              ) {
                var i = window.inventories[this.productId][t.id];
                if ("continue" === i.policy) {
                  this.toggleInventoryQuantity(t, !1),
                    this.toggleIncomingInventory(!1);
                  return;
                }
                var n = i.quantity,
                  s = !0,
                  a = !1;
                (n <= 0 || n > this.settings.inventoryThreshold) && (s = !1),
                  this.toggleInventoryQuantity(t, s, n),
                  !s &&
                    "true" === i.incoming &&
                    n <= this.settings.inventoryThreshold &&
                    (a = !0),
                  this.toggleIncomingInventory(
                    a,
                    t.available,
                    i.next_incoming_date
                  );
              }
            },
            updateAvailability: function (e) {
              var t = e.detail.variant;
              t && this.storeAvailability.updateContent(t.id);
            },
            toggleInventoryQuantity: function (e, i, n) {
              this.settings.inventory || (i = !1);
              var s = this.container.querySelector(this.selectors.inventory),
                a = s.closest(".product-block");
              parseInt(n) <= parseInt(this.settings.inventoryThreshold)
                ? (s.parentNode.classList.add("inventory--low"),
                  (s.textContent = theme.strings.stockLabel.replace(
                    "[count]",
                    n
                  )))
                : (s.parentNode.classList.remove("inventory--low"),
                  (s.textContent = theme.strings.inStockLabel)),
                e && e.available
                  ? (s.parentNode.classList.remove(t.hidden),
                    a && a.classList.remove(t.hidden))
                  : (s.parentNode.classList.add(t.hidden),
                    a && a.classList.add(t.hidden));
            },
            toggleIncomingInventory: function (e, i, n) {
              var s = this.container.querySelector(
                  this.selectors.incomingInventory
                ),
                a = s.closest(".product-block");
              if (s) {
                var o = s.querySelector(".js-incoming-text");
                if (e) {
                  var r = i
                    ? theme.strings.willNotShipUntil.replace("[date]", n)
                    : theme.strings.willBeInStockAfter.replace("[date]", n);
                  n || (r = theme.strings.waitingForStock),
                    s.classList.remove(t.hidden),
                    a && a.classList.remove(t.hidden),
                    (o.textContent = r);
                } else s.classList.add(t.hidden);
              }
            },
            videoSetup: function () {
              var e = this.cache.mainSlider.querySelectorAll(i.productVideo);
              if (!e.length) return !1;
              e.forEach((e) => {
                var t = e.dataset.videoType;
                "youtube" === t
                  ? this.initYoutubeVideo(e)
                  : "mp4" === t && this.initMp4Video(e);
              });
            },
            initYoutubeVideo: function (t) {
              e[t.id] = new theme.YouTube(t.id, {
                videoId: t.dataset.youtubeId,
                videoParent: i.videoParent,
                autoplay: !1,
                style: t.dataset.videoStyle,
                loop: t.dataset.videoLoop,
                events: {
                  onReady: this.youtubePlayerReady.bind(this),
                  onStateChange: this.youtubePlayerStateChange.bind(this),
                },
              });
            },
            youtubePlayerReady: function (t) {
              var i = t.target.getIframe().id;
              if (e[i]) {
                var n = e[i],
                  s = n.videoPlayer;
                "sound" !== n.options.style && s.mute(),
                  n.parent.classList.remove("loading"),
                  n.parent.classList.add("loaded"),
                  this._isFirstSlide(i) &&
                    "sound" !== n.options.style &&
                    s.playVideo();
              }
            },
            _isFirstSlide: function (e) {
              return this.cache.mainSlider.querySelector(
                i.startingSlide + " #" + e
              );
            },
            youtubePlayerStateChange: function (t) {
              var i = e[t.target.getIframe().id];
              switch (t.data) {
                case -1:
                  i.attemptedToPlay &&
                    i.parent.classList.add("video-interactable");
                  break;
                case 0:
                  i && "true" === i.options.loop && i.videoPlayer.playVideo();
                  break;
                case 3:
                  i.attemptedToPlay = !0;
              }
            },
            initMp4Video: function (t) {
              (e[t.id] = { id: t.id, type: "mp4" }),
                this._isFirstSlide(t.id) && this.playMp4Video(t.id);
            },
            stopVideos: function () {
              for (var [t, i] of Object.entries(e))
                i.videoPlayer
                  ? "function" == typeof i.videoPlayer.stopVideo &&
                    i.videoPlayer.stopVideo()
                  : "mp4" === i.type && this.stopMp4Video(i.id);
            },
            _getVideoType: function (e) {
              return e.getAttribute("data-video-type");
            },
            _getVideoDivId: function (e) {
              return e.id;
            },
            playMp4Video: function (e) {
              var t = this.container.querySelector("#" + e),
                n = t.play();
              void 0 !== n &&
                n
                  .then(function () {})
                  .catch(function (e) {
                    t.setAttribute("controls", ""),
                      t
                        .closest(i.videoParent)
                        .setAttribute("data-video-style", "unmuted");
                  });
            },
            stopMp4Video: function (e) {
              var t = this.container.querySelector("#" + e);
              t && "function" == typeof t.pause && t.pause();
            },
            initImageZoom: function () {
              var e = this.container.querySelector(
                this.selectors.imageContainer
              );
              e &&
                (new theme.Photoswipe(e, this.sectionId),
                e.addEventListener(
                  "photoswipe:afterChange",
                  function (e) {
                    this.flickity && this.flickity.goToSlide(e.detail.index);
                  }.bind(this)
                ));
            },
            getThumbIndex: function (e) {
              return e.dataset.index;
            },
            updateVariantImage: function (e) {
              var t = e.detail.variant;
              theme.Images.getSizedImageUrl(
                t.featured_media.preview_image.src,
                this.settings.imageSize
              );
              var i = this.container.querySelector(
                  '.product__thumb[data-id="' + t.featured_media.id + '"]'
                ),
                n = this.getThumbIndex(i);
              void 0 !== n && this.flickity && this.flickity.goToSlide(n);
            },
            initProductSlider: function (e) {
              if (this.cache.mainSlider.querySelectorAll(i.slide).length <= 1) {
                var t = this.cache.mainSlider.querySelector(i.slide);
                t && t.classList.add("is-selected");
                return;
              }
              if (
                (this.flickity &&
                  "function" == typeof this.flickity.destroy &&
                  this.flickity.destroy(),
                !e)
              ) {
                var n = this.cache.mainSlider.querySelector(i.startingSlide);
                this.settings.currentSlideIndex = this._slideIndex(n);
              }
              var s = {
                adaptiveHeight: !0,
                avoidReflow: !0,
                initialIndex: this.settings.currentSlideIndex,
                childNav: this.cache.thumbSlider,
                childNavScroller: this.cache.thumbScroller,
                childVertical:
                  "beside" === this.cache.thumbSlider.dataset.position,
                wrapAround: !1,
                callbacks: {
                  onInit: this.onSliderInit.bind(this),
                  onChange: this.onSlideChange.bind(this),
                },
              };
              this.settings.imageSetName &&
                ((s = Object.assign({}, s, this.imageSetArguments(e))),
                this.updateImageSetThumbs(s.imageSet)),
                (this.flickity = new theme.Slideshow(this.cache.mainSlider, s));
            },
            onSliderInit: function (e) {
              this.settings.imageSetName && this.prepMediaOnSlide(e);
            },
            onSlideChange: function (e) {
              if (this.flickity) {
                var t = this.cache.mainSlider.querySelector(
                    '.product-main-slide[data-index="' +
                      this.settings.currentSlideIndex +
                      '"]'
                  ),
                  i = this.settings.imageSetName
                    ? this.cache.mainSlider.querySelectorAll(
                        ".flickity-slider .product-main-slide"
                      )[e]
                    : this.cache.mainSlider.querySelector(
                        '.product-main-slide[data-index="' + e + '"]'
                      );
                t.setAttribute("tabindex", "-1"),
                  i.setAttribute("tabindex", 0),
                  this.stopMediaOnSlide(t),
                  this.prepMediaOnSlide(i),
                  (this.settings.currentSlideIndex = e);
              }
            },
            stopMediaOnSlide(t) {
              var n = t.querySelector(i.productVideo);
              if (n) {
                var s = this._getVideoType(n),
                  a = this._getVideoDivId(n);
                if ("youtube" === s) {
                  if (e[a].videoPlayer) {
                    e[a].videoPlayer.stopVideo();
                    return;
                  }
                } else if ("mp4" === s) {
                  this.stopMp4Video(a);
                  return;
                }
              }
              var o = t.querySelector(this.selectors.media);
              o &&
                o.dispatchEvent(
                  new CustomEvent("mediaHidden", {
                    bubbles: !0,
                    cancelable: !0,
                  })
                );
            },
            prepMediaOnSlide(t) {
              var n = t.querySelector(i.productVideo);
              if (n) {
                this.flickity.reposition();
                var s = this._getVideoType(n),
                  a = this._getVideoDivId(n);
                if ("youtube" === s) {
                  if (e[a].videoPlayer && "sound" !== e[a].options.style) {
                    e[a].videoPlayer.playVideo();
                    return;
                  }
                } else "mp4" === s && this.playMp4Video(a);
              }
              var o = t.querySelector(this.selectors.media);
              o &&
                (o.dispatchEvent(
                  new CustomEvent("mediaVisible", {
                    bubbles: !0,
                    cancelable: !0,
                  })
                ),
                t
                  .querySelector(".shopify-model-viewer-ui__button")
                  .setAttribute("tabindex", 0),
                t
                  .querySelector(".product-single__close-media")
                  .setAttribute("tabindex", 0));
            },
            _slideIndex: function (e) {
              return e.getAttribute("data-index");
            },
            openModalProduct: function () {
              var e = !1;
              this.settings.modalInit
                ? (e = !0)
                : ((this.blocksHolder = this.container.querySelector(
                    i.blocksHolder
                  )),
                  fetch(this.blocksHolder.dataset.url)
                    .then(function (e) {
                      return e.text();
                    })
                    .then(
                      function (e) {
                        var t = new DOMParser()
                          .parseFromString(e, "text/html")
                          .querySelector(i.blocks);
                        t.querySelectorAll("[id]").forEach((e) => {
                          var i = e.getAttribute("id");
                          e.setAttribute("id", i + "-modal");
                          var n = t.querySelector(`[for="${i}"]`);
                          n && n.setAttribute("for", i + "-modal");
                          var s = t.querySelector(`[aria-controls="${i}"]`);
                          s && s.setAttribute("aria-controls", i + "-modal");
                        });
                        var n = t
                          .querySelector(this.selectors.form)
                          .getAttribute("id");
                        t.querySelectorAll("[form]").forEach((e) => {
                          e.setAttribute("form", n);
                        }),
                          (this.blocksHolder.innerHTML = ""),
                          this.blocksHolder.append(t),
                          this.blocksHolder.classList.add(
                            "product-form-holder--loaded"
                          ),
                          this.cacheElements(),
                          this.formSetup(),
                          this.updateModalProductInventory(),
                          Shopify &&
                            Shopify.PaymentButton &&
                            Shopify.PaymentButton.init(),
                          theme.collapsibles.init(this.container),
                          document.dispatchEvent(
                            new CustomEvent("quickview:loaded", {
                              detail: { productId: this.sectionId },
                            })
                          );
                      }.bind(this)
                    ),
                  this.productSetup(),
                  this.videoSetup(),
                  this.settings.imageSetName
                    ? this.variants
                      ? this.initProductSlider()
                      : document.addEventListener(
                          "quickview:loaded",
                          function (e) {
                            e.detail.productId === this.sectionId &&
                              this.initProductSlider();
                          }.bind(this)
                        )
                    : this.initProductSlider(),
                  this.customMediaListners(),
                  (this.settings.modalInit = !0)),
                AOS.refreshHard(),
                document.dispatchEvent(
                  new CustomEvent("quickview:open", {
                    detail: { initialized: e, productId: this.sectionId },
                  })
                );
            },
            updateModalProductInventory: function () {
              (window.inventories = window.inventories || {}),
                this.container
                  .querySelectorAll(".js-product-inventory-data")
                  .forEach((e) => {
                    var t = e.dataset.productId;
                    (window.inventories[t] = {}),
                      e
                        .querySelectorAll(".js-variant-inventory-data")
                        .forEach((e) => {
                          window.inventories[t][e.dataset.id] = {
                            quantity: e.dataset.quantity,
                            policy: e.dataset.policy,
                            incoming: e.dataset.incoming,
                            next_incoming_date: e.dataset.date,
                          };
                        });
                  });
            },
            closeModalProduct: function () {
              this.stopVideos();
            },
            initModelViewerLibraries: function () {
              var e = this.container.querySelectorAll(this.selectors.media);
              e.length < 1 || theme.ProductMedia.init(e, this.sectionId);
            },
            initShopifyXrLaunch: function () {
              document.addEventListener(
                "shopify_xr_launch",
                function () {
                  this.container
                    .querySelector(
                      this.selectors.productMediaWrapper +
                        ":not(." +
                        self.classes.hidden +
                        ")"
                    )
                    .dispatchEvent(
                      new CustomEvent("xrLaunch", {
                        bubbles: !0,
                        cancelable: !0,
                      })
                    );
                }.bind(this)
              );
            },
            customMediaListners: function () {
              document
                .querySelectorAll(this.selectors.closeMedia)
                .forEach((e) => {
                  e.addEventListener(
                    "click",
                    function () {
                      var e = this.cache.mainSlider
                        .querySelector(i.currentSlide)
                        .querySelector(this.selectors.media);
                      e &&
                        e.dispatchEvent(
                          new CustomEvent("mediaHidden", {
                            bubbles: !0,
                            cancelable: !0,
                          })
                        );
                    }.bind(this)
                  );
                });
              var e = this.container.querySelectorAll("model-viewer");
              e.length &&
                e.forEach((e) => {
                  e.addEventListener(
                    "shopify_model_viewer_ui_toggle_play",
                    function (e) {
                      this.mediaLoaded(e);
                    }.bind(this)
                  ),
                    e.addEventListener(
                      "shopify_model_viewer_ui_toggle_pause",
                      function (e) {
                        this.mediaUnloaded(e);
                      }.bind(this)
                    );
                });
            },
            mediaLoaded: function (e) {
              this.container
                .querySelectorAll(this.selectors.closeMedia)
                .forEach((e) => {
                  e.classList.remove(t.hidden);
                }),
                this.flickity && this.flickity.setDraggable(!1);
            },
            mediaUnloaded: function (e) {
              this.container
                .querySelectorAll(this.selectors.closeMedia)
                .forEach((e) => {
                  e.classList.add(t.hidden);
                }),
                this.flickity && this.flickity.setDraggable(!0);
            },
          })),
          n
        );
      })()),
      (theme.Testimonials = (function () {
        var e = {
          adaptiveHeight: !0,
          avoidReflow: !0,
          pageDots: !0,
          prevNextButtons: !1,
        };
        function t(e) {
          this.container = e;
          var t = e.getAttribute("data-section-id");
          (this.slideshow = e.querySelector("#Testimonials-" + t)),
            (this.namespace = ".testimonial-" + t),
            this.slideshow &&
              theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 600,
              });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.slideshow.dataset.count <= 3 && (e.wrapAround = !1),
                (this.flickity = new theme.Slideshow(this.slideshow, e)),
                this.slideshow.dataset.count > 3 &&
                  setTimeout(
                    function () {
                      this.flickity.goToSlide(1);
                    }.bind(this),
                    1e3
                  );
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (e) {
              var t = parseInt(
                this.slideshow.querySelector(
                  ".testimonials-slide--" + e.detail.blockId
                ).dataset.index
              );
              this.flickity &&
                "function" == typeof this.flickity.pause &&
                (this.flickity.goToSlide(t), this.flickity.pause());
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.isSessionStorageSupported = function () {
        if (window.self !== window.top) return !1;
        var e = "test",
          t = window.sessionStorage;
        try {
          return t.setItem(e, "1"), t.removeItem(e), !0;
        } catch (i) {
          return !1;
        }
      }),
      (theme.reinitProductGridItem = function (e) {
        AOS && AOS.refreshHard(),
          theme.initQuickShop(),
          window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
          theme.collapsibles.init();
      }),
      (theme.config.hasSessionStorage = theme.isSessionStorageSupported()),
      AOS.init({
        easing: "ease-out-quad",
        once: !0,
        offset: 60,
        disableMutationObserver: !0,
      }),
      (theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches),
      matchMedia(theme.config.mediaQuerySmall).addListener(function (e) {
        e.matches
          ? ((theme.config.bpSmall = !0),
            document.dispatchEvent(new CustomEvent("matchSmall")))
          : ((theme.config.bpSmall = !1),
            document.dispatchEvent(new CustomEvent("unmatchSmall")));
      }),
      (theme.initGlobals = function () {
        theme.collapsibles.init(), theme.videoModal();
      }),
      (r = function () {
        if (
          ((theme.sections = new theme.Sections()),
          theme.sections.register("slideshow-section", theme.SlideshowSection),
          theme.sections.register("header", theme.HeaderSection),
          theme.sections.register("footer", theme.FooterSection),
          theme.sections.register("product", theme.Product),
          theme.sections.register("password-header", theme.PasswordHeader),
          theme.sections.register(
            "collection-switcher",
            theme.CollectionSwitcher
          ),
          theme.sections.register("map", theme.Maps),
          theme.sections.register("blog", theme.Blog),
          theme.sections.register("newsletter-popup", theme.NewsletterPopup),
          theme.sections.register(
            "product-recommendations",
            theme.Recommendations
          ),
          theme.sections.register("video-section", theme.VideoSection),
          theme.sections.register("photoswipe", theme.Photoswipe),
          theme.sections.register(
            "store-availability",
            theme.StoreAvailability
          ),
          theme.sections.register("fading-images", theme.FadingImages),
          theme.sections.register("testimonials", theme.Testimonials),
          theme.sections.register("background-image", theme.BackgroundImage),
          theme.sections.register("collection-template", theme.Collection),
          theme.initGlobals(),
          theme.initQuickShop(),
          theme.rteInit(),
          theme.articleImages(),
          document.body.classList.contains("template-cart"))
        ) {
          var e = document.getElementById("CartPageForm");
          e && new theme.CartForm(e);
        }
        theme.settings.predictiveSearch && theme.predictiveSearch.init(),
          theme.settings.isCustomerTemplate && theme.customerTemplates(),
          theme.pageTransitions(),
          document.dispatchEvent(new CustomEvent("page:loaded"));
      }),
      "loading" != document.readyState
        ? r()
        : document.addEventListener("DOMContentLoaded", r);
  })();

function productImageSlider() {
  $(".slider_images").slick({
    centerMode: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 7000,
    autoplay: true,
    autoplaySpeed: 0,
    infinite: true,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  productImageSlider();
});
document.addEventListener("shopify:section:load", productImageSlider);




